
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("bvwqZ", function(module, exports) {

$parcel$export(module.exports, "UpgradeOnboardingExperiment", () => $4b7ec2ad9c06547f$export$70b554b486395223);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $hA9Bj = parcelRequire("hA9Bj");

var $7ZZxN = parcelRequire("7ZZxN");

var $1Iui1 = parcelRequire("1Iui1");

var $0cdA8 = parcelRequire("0cdA8");

var $cPEpP = parcelRequire("cPEpP");


var $iXvmm = parcelRequire("iXvmm");

var $5mjno = parcelRequire("5mjno");
const $4b7ec2ad9c06547f$export$70b554b486395223 = ()=>{
    const { loading: loadingProject, data: project } = (0, $cPEpP.useProject)();
    const projectType = project?.type && (0, $7ZZxN.toProjectType)(project.type);
    const cohort = !loadingProject && projectType && (0, $5mjno.getUpgradeOnboardingCohort)(projectType) || (0, $1Iui1.NOT_ENROLLED);
    const isUpgradeOnboardingEnabled = [
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.VARIATION)
    ].includes(cohort);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    if (!loadingProject && (0, $5mjno.isSupportedProjectType)(projectType) && isUpgradeOnboardingEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $20c0bbc97fb7b0c7$export$55e69d32017fcb98),
        fallback: "unmount",
        onError: (err)=>{
            (0, $hA9Bj.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: (0, $20c0bbc97fb7b0c7$export$55e69d32017fcb98),
                action: (0, $20c0bbc97fb7b0c7$export$6a238c78062d3b8d)
            }), {
                error: err
            });
        },
        teamName: (0, $20c0bbc97fb7b0c7$export$d57b6b390e78d90f),
        packageName: (0, $20c0bbc97fb7b0c7$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iXvmm.UpgradeOnboardingExperimentComponent), {
        projectType: projectType
    }));
    return null;
};

});
parcelRegister("hA9Bj", function(module, exports) {

$parcel$export(module.exports, "fireAnalytics", () => $cccd3efbce192aa3$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $cccd3efbce192aa3$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $cccd3efbce192aa3$export$13990ad4625571ed);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $cccd3efbce192aa3$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireScreenAnalytics", () => $cccd3efbce192aa3$export$6f46fb37ad7d962b);

var $iTvqy = parcelRequire("iTvqy");


var $7VEyJ = parcelRequire("7VEyJ");
const $cccd3efbce192aa3$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $90b2199425b10123$export$2ceccf177fae277c));
};
const $cccd3efbce192aa3$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $cccd3efbce192aa3$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $7VEyJ.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $cccd3efbce192aa3$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $cccd3efbce192aa3$export$34ac71ce24cddec2(event, (0, $90b2199425b10123$export$a1562d08625f5d7e), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $cccd3efbce192aa3$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $7VEyJ.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $cccd3efbce192aa3$export$34ac71ce24cddec2(event, (0, $90b2199425b10123$export$947dac6c72b26f81), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $cccd3efbce192aa3$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $7VEyJ.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $cccd3efbce192aa3$export$34ac71ce24cddec2(event, (0, $90b2199425b10123$export$12346a674644c156), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $cccd3efbce192aa3$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $7VEyJ.getImperativeAnalyticsDataFromArguments)(rest);
    $cccd3efbce192aa3$export$34ac71ce24cddec2(event, (0, $90b2199425b10123$export$f1d537d508d2945a), {
        attributes: attributes
    });
};

});
const $90b2199425b10123$export$f636b5b56f1d624a = 'Screen';
const $90b2199425b10123$export$9d2de6eebf7462b5 = 'Drawer';
const $90b2199425b10123$export$1171103ea9083ffa = 'Modal';
const $90b2199425b10123$export$cae2783c9279926 = 'InlineDialog';
const $90b2199425b10123$export$d1123261ca8831d2 = 'Dropdown';
const $90b2199425b10123$export$a1562d08625f5d7e = 'UI';
const $90b2199425b10123$export$947dac6c72b26f81 = 'TRACK';
const $90b2199425b10123$export$f1d537d508d2945a = 'SCREEN';
const $90b2199425b10123$export$12346a674644c156 = 'OPERATIONAL';
const $90b2199425b10123$export$2ceccf177fae277c = 'analyticsBridge';

parcelRegister("7VEyJ", function(module, exports) {

$parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", () => $5c5d517ab0f18495$export$e6baab532ef8c6bf);
const $5c5d517ab0f18495$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $5c5d517ab0f18495$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $5c5d517ab0f18495$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $5c5d517ab0f18495$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $5c5d517ab0f18495$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $5c5d517ab0f18495$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $5c5d517ab0f18495$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $5c5d517ab0f18495$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $5c5d517ab0f18495$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $5c5d517ab0f18495$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $5c5d517ab0f18495$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $5c5d517ab0f18495$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};

});


parcelRegister("1Iui1", function(module, exports) {

$parcel$export(module.exports, "COHORT", () => $1524157debf2fd00$export$3d370c33621572df);
$parcel$export(module.exports, "NOT_ENROLLED", () => $1524157debf2fd00$export$5b7423264d48ab04);
$parcel$export(module.exports, "CONTROL", () => $1524157debf2fd00$export$43f367b3e957f219);
$parcel$export(module.exports, "EXPERIMENT", () => $1524157debf2fd00$export$9ba2bc3b1bdc1519);
$parcel$export(module.exports, "VARIATION", () => $1524157debf2fd00$export$fa04ad826acc90da);
$parcel$export(module.exports, "VAR1", () => $1524157debf2fd00$export$6486974e39493fa6);
$parcel$export(module.exports, "VAR2", () => $1524157debf2fd00$export$7d994996134ad562);

var $1ybV0 = parcelRequire("1ybV0");
const $1524157debf2fd00$export$3d370c33621572df = 'cohort';
const $1524157debf2fd00$export$5b7423264d48ab04 = 'not-enrolled';
const $1524157debf2fd00$export$43f367b3e957f219 = 'control';
const $1524157debf2fd00$export$9ba2bc3b1bdc1519 = 'experiment';
const $1524157debf2fd00$export$fa04ad826acc90da = 'variation';
const $1524157debf2fd00$export$6486974e39493fa6 = 'variation-1';
const $1524157debf2fd00$export$7d994996134ad562 = 'variation-2';
const $1524157debf2fd00$export$795e7d69b248dcd0 = 'variation-3';
const $1524157debf2fd00$export$c9c947c57470b787 = 'variation-4';
const $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $1524157debf2fd00$export$5b7423264d48ab04,
    $1524157debf2fd00$export$43f367b3e957f219,
    $1524157debf2fd00$export$9ba2bc3b1bdc1519,
    $1524157debf2fd00$export$fa04ad826acc90da,
    $1524157debf2fd00$export$6486974e39493fa6,
    $1524157debf2fd00$export$7d994996134ad562,
    $1524157debf2fd00$export$795e7d69b248dcd0,
    $1524157debf2fd00$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$1524157debf2fd00$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $1ybV0.getMultivariateFeatureFlag)(experimentFeatureFlag, $1524157debf2fd00$export$5b7423264d48ab04, validExperimentGroups);

});

const $20c0bbc97fb7b0c7$export$b8b9d90f9e5bd72b = 'jiraUpgradeOnboardingExperiment';
const $20c0bbc97fb7b0c7$export$d57b6b390e78d90f = 'transmuters-growth';
const $20c0bbc97fb7b0c7$export$a842ad7d572fbccf = 'upgrade-onboarding-experiment-modal-viewed';
const $20c0bbc97fb7b0c7$export$58dd42d73affe399 = 'upgrade-onboarding-experiment-dismiss';
const $20c0bbc97fb7b0c7$export$4ddf07b00a2c2bc4 = 'upgrade-onboarding-experiment';
const $20c0bbc97fb7b0c7$export$8b4682bf35504518 = 'sendOperationalEvent';
const $20c0bbc97fb7b0c7$export$eb3c99601284633 = 'sendUIEvent';
const $20c0bbc97fb7b0c7$export$b3bebfc20c8d4ea = 'sendTrackEvent';
const $20c0bbc97fb7b0c7$export$6d01cae610456af2 = 'success';
const $20c0bbc97fb7b0c7$export$6a238c78062d3b8d = 'failed';
const $20c0bbc97fb7b0c7$export$ed2457f6e4fab64 = 'exposed';
const $20c0bbc97fb7b0c7$export$99eda8c92da59583 = 'clicked';
const $20c0bbc97fb7b0c7$export$e13d91eb874cb062 = 'feature';
const $20c0bbc97fb7b0c7$export$9eee3f7eec5c9126 = 'button';
const $20c0bbc97fb7b0c7$export$5824144caaec3f1e = 'refreshPageButton';
const $20c0bbc97fb7b0c7$export$17116f7e9ce47a15 = 'fetchSiteUpgradedApiCall';
const $20c0bbc97fb7b0c7$export$efda9b1e7fc817d3 = 'fetchPaymentInformation';
const $20c0bbc97fb7b0c7$export$d094ee3fcda994eb = 'getUserPropertyApiCall';
const $20c0bbc97fb7b0c7$export$f3310dd86ae4284b = 'setUserPropertyApiCall';
const $20c0bbc97fb7b0c7$export$4119d842f9fd3189 = 'dismissTrialPillSpotlight';
const $20c0bbc97fb7b0c7$export$55e69d32017fcb98 = 'upgradeOnboardingExperiment';

parcelRegister("iXvmm", function(module, exports) {

$parcel$export(module.exports, "UpgradeOnboardingExperimentComponent", () => $858641070cfed9e1$export$697de072b95f4472);

var $cfRek = parcelRequire("cfRek");

var $eUqFw = parcelRequire("eUqFw");

var $dlGXX = parcelRequire("dlGXX");

var $iWLL0 = parcelRequire("iWLL0");

var $bFzGY = parcelRequire("bFzGY");

var $jMP2a = parcelRequire("jMP2a");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");

var $gd0Sp = parcelRequire("gd0Sp");


var $85KBV = parcelRequire("85KBV");

var $3tHIq = parcelRequire("3tHIq");

var $1YPBj = parcelRequire("1YPBj");

var $33DwA = parcelRequire("33DwA");

var $5mjno = parcelRequire("5mjno");
const $858641070cfed9e1$export$62297b13309008b2 = (0, $cfRek.default);
const $858641070cfed9e1$var$sendSuccessAnalytics = (createAnalyticsEvent, data)=>{
    const analyticsSetSuccessEvent = createAnalyticsEvent({
        type: (0, $20c0bbc97fb7b0c7$export$8b4682bf35504518),
        action: (0, $20c0bbc97fb7b0c7$export$6d01cae610456af2),
        actionSubject: (0, $20c0bbc97fb7b0c7$export$efda9b1e7fc817d3)
    });
    (0, $jMP2a.fireOperationalAnalytics)(analyticsSetSuccessEvent, `${(0, $20c0bbc97fb7b0c7$export$efda9b1e7fc817d3)} ${(0, $20c0bbc97fb7b0c7$export$6d01cae610456af2)}`, {
        data: data
    });
};
const $858641070cfed9e1$export$697de072b95f4472 = ({ projectType: projectType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId, appEditions: appEditions, productEntitlementDetails: productEntitlementDetails } = (0, $gd0Sp.useTenantContext)();
    const editionFromTenantContext = (0, $6WXNs.getEdition)((0, $eIp1n.getApplicationForProject)(projectType), appEditions);
    const product = (0, $5mjno.projectTypeToApplicationKey)(projectType);
    const [canProceed, setCanProceed] = (0, $eUqFw.useState)(false);
    const hasBeenUpgradedFromFree = (0, $3tHIq.useHasBeenUpgradedFromFree)({
        currentEdition: editionFromTenantContext,
        product: product
    });
    (0, $eUqFw.useEffect)(()=>{
        (async ()=>{
            if (editionFromTenantContext === (0, $6WXNs.STANDARD_EDITION)) {
                const entitlementDetails = productEntitlementDetails?.[product];
                if (!atlassianAccountId || !entitlementDetails) return;
                const billingSourceSystem = entitlementDetails.billingSourceSystem;
                const trialEndTime = entitlementDetails.trialEndTime;
                const isOnTrial = trialEndTime && (0, $dlGXX.default)(trialEndTime, Date.now());
                if (isOnTrial && entitlementDetails.entitlementId) {
                    const wasModalViewed = await (0, $1YPBj.getModalViewedProperty)(createAnalyticsEvent, projectType, atlassianAccountId);
                    if (!wasModalViewed) {
                        if (billingSourceSystem === 'CCP') {
                            setCanProceed(true);
                            return;
                        }
                        const hasUpgraded = await (0, $85KBV.isUpgradedBasedOnTraits)(product, cloudId, undefined);
                        setCanProceed(hasUpgraded);
                    }
                }
            }
        })();
    }, [
        atlassianAccountId,
        cloudId,
        createAnalyticsEvent,
        editionFromTenantContext,
        product,
        productEntitlementDetails,
        productEntitlementDetails?.entitlementId,
        projectType
    ]);
    const isEnabled = hasBeenUpgradedFromFree || canProceed;
    return isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($858641070cfed9e1$export$70b554b486395223, {
        projectType: projectType
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};
const $858641070cfed9e1$export$70b554b486395223 = ({ projectType: projectType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const data = (0, $iWLL0.useLazyLoadQuery)($858641070cfed9e1$export$62297b13309008b2, {
        cloudId: cloudId,
        hamsProductKey: (0, $5mjno.projectToProductKey)(projectType)
    });
    (0, $eUqFw.useEffect)(()=>{
        data && $858641070cfed9e1$var$sendSuccessAnalytics(createAnalyticsEvent, data);
    }, [
        createAnalyticsEvent,
        data
    ]);
    const entitlement = data?.tenantContexts && data.tenantContexts.length > 0 ? data.tenantContexts[0]?.entitlementInfo?.entitlement : undefined;
    const invoiceGroup = entitlement?.subscription?.accountDetails?.invoiceGroup;
    const addPaymentMethod = entitlement?.transactionAccount?.experienceCapabilities?.addPaymentMethod;
    // transactionAccountId can only exist if the billing system is CCP
    const transactionAccountId = entitlement?.transactionAccountId;
    const configurePaymentCapability = invoiceGroup?.experienceCapabilities?.configurePayment;
    const invoiceable = invoiceGroup?.invoiceable;
    const canPay = Boolean(configurePaymentCapability?.isAvailableToUser || addPaymentMethod?.isAvailableToUser);
    const { isLoading: isLoadingEntitlements, hasMultiple: hasMultiple } = (0, $3tHIq.useHasMultipleCCPProducts)(projectType, canPay && !invoiceable, transactionAccountId);
    // check experiment enrollment conditions
    const isEnabled = // only enroll if user can actually add payment details
    canPay && // only enroll if site doesn't have payment details
    !invoiceable && // we can only tell if a site has been upgraded once per product per transactionAccountId
    // so we exclude sites with multiples of the same product associated to their transaction account
    !isLoadingEntitlements && !hasMultiple;
    return isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $33DwA.ExperimentContainer), {
        addPaymentMethodRef: addPaymentMethod,
        projectType: projectType,
        transactionAccountId: transactionAccountId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};

});
parcelRegister("cfRek", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c0de28c9498d651$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<998eb668ceac2dbd9143fb02c14b1067>>
 * @relayHash c318c6546708c3e28862d13d0addc72b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c38b4eddc0d5f7c4606c2f74850af0ddf001e50a39877ec0a51406543d1a17e4
const $8c0de28c9498d651$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "transactionAccountId"
            }
        ],
        "type": "CcpEntitlement"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v5 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_UpgradeOnboarding_EntitlementInfo_Query",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "addPaymentMethod",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "FragmentSpread",
                                                                    "name": "main_upgradeOnboardingExperiment_UpgradeOnboardingModal"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePayment",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_UpgradeOnboarding_EntitlementInfo_Query",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "addPaymentMethod",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isCommerceExperienceCapability"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "experienceUrl"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "CcpTransactionAccount"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePayment",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v6 /*: any*/ ,
                                                                                v4 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v8 /*: any*/ ,
                                                                    "type": "CcpInvoiceGroup"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "CcpSubscription"
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c38b4eddc0d5f7c4606c2f74850af0ddf001e50a39877ec0a51406543d1a17e4",
            "metadata": {},
            "name": "main_UpgradeOnboarding_EntitlementInfo_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8c0de28c9498d651$var$node.hash = "ec37b453f3bae6be9982dc68bddd477e";
var $8c0de28c9498d651$export$2e2bcd8739ae039 = $8c0de28c9498d651$var$node;

});

parcelRegister("85KBV", function(module, exports) {

$parcel$export(module.exports, "fetchSiteTraits", () => $d2622b4acc5227c2$export$954f05a5dfd487e4);
$parcel$export(module.exports, "isUpgradedBasedOnTraits", () => $d2622b4acc5227c2$export$6a43fbafebde4e35);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $cfSGT = parcelRequire("cfSGT");
const $d2622b4acc5227c2$export$954f05a5dfd487e4 = async (cloudId)=>{
    try {
        const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
        const response = await (0, $lRmyA.performGetRequest)(url);
        if (response?.attributes) return response.attributes;
        throw Error('response is not defined or null');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'jiraUpgradeOnboardingExperiment',
                packageName: 'jiraUpgradeOnboardingExperiment',
                teamName: 'transmuters-growth'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return [];
};
const $d2622b4acc5227c2$export$ba34ed404c066e51 = async (cloudId, product)=>{
    const response = await $d2622b4acc5227c2$export$954f05a5dfd487e4(cloudId);
    return response.some((trait)=>(0, $cfSGT.UPGRADE_ONBOARDING_PRODUCT_TRAIT_MAP).get(product)?.includes(trait.name));
};
const $d2622b4acc5227c2$export$6a43fbafebde4e35 = async (product, cloudId, transactionAccountId)=>{
    // normally the trait can be retrieved with just the cloud id but if it was a manual upgrade from
    // ccp, we also need to check the personalization api with the transactionAccountId
    let isUpgraded = await $d2622b4acc5227c2$export$ba34ed404c066e51(cloudId, product);
    // transactionAccountId is needed when it is a manual upgrade from a ccp account
    if (transactionAccountId && !isUpgraded) isUpgraded = await $d2622b4acc5227c2$export$ba34ed404c066e51(transactionAccountId, product);
    return isUpgraded;
};

});
parcelRegister("cfSGT", function(module, exports) {

$parcel$export(module.exports, "UPGRADE_ONBOARDING_PRODUCT_TRAIT_MAP", () => $97c5af0de252eb37$export$85ae352a91649be8);

const $97c5af0de252eb37$export$6a3207c283394a3a = 'jira-software-billing-console_track_upgrade_success_client_first';
const $97c5af0de252eb37$export$4d780acd61e85428 = 'jira-software-admin_track_upgrade_success_client_first';
const $97c5af0de252eb37$export$7457bf13eeb1fb95 = 'jira-servicemanagement-billing-console_track_upgrade_success_client_first';
const $97c5af0de252eb37$export$2747666cbb5540a2 = 'jira-servicemanagement-admin_track_upgrade_success_client_first';
const $97c5af0de252eb37$export$fc9b57b21df17347 = 'jira-product-discovery_track_upgrade_success_client_first';
const $97c5af0de252eb37$export$cdf5bbf67df73c25 = 'jira-product-discovery_operational_upgrade_success_auto_upgrade_server_first';
const $97c5af0de252eb37$export$c776e3431da5a718 = 'jira-servicemanagement_operational_upgrade_success_auto_upgrade_server_first';
const $97c5af0de252eb37$export$78bd30b137f89287 = 'jira-software_operational_upgrade_success_auto_upgrade_server_first';
const $97c5af0de252eb37$export$85ae352a91649be8 = new Map(Object.entries({
    [(0, $2edfd53057852e41$export$1346c9aa3cbb477d)]: [
        $97c5af0de252eb37$export$6a3207c283394a3a,
        $97c5af0de252eb37$export$4d780acd61e85428,
        $97c5af0de252eb37$export$78bd30b137f89287
    ],
    [(0, $2edfd53057852e41$export$c8c1c8c3f8ddba61)]: [
        $97c5af0de252eb37$export$7457bf13eeb1fb95,
        $97c5af0de252eb37$export$2747666cbb5540a2,
        $97c5af0de252eb37$export$c776e3431da5a718
    ],
    [(0, $2edfd53057852e41$export$202f50ee62667e32)]: [
        $97c5af0de252eb37$export$fc9b57b21df17347,
        $97c5af0de252eb37$export$cdf5bbf67df73c25
    ]
}));

});
const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';



parcelRegister("3tHIq", function(module, exports) {

$parcel$export(module.exports, "useHasBeenUpgradedFromFree", () => $bf5bb01986a86241$export$85f35a76872f3a15);
$parcel$export(module.exports, "useHasMultipleCCPProducts", () => $bf5bb01986a86241$export$f7ece173fbdc007);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $ecLYJ = parcelRequire("ecLYJ");

var $808rz = parcelRequire("808rz");

var $jMP2a = parcelRequire("jMP2a");

var $6WXNs = parcelRequire("6WXNs");


var $5mjno = parcelRequire("5mjno");

var $aX8d7 = parcelRequire("aX8d7");
const $bf5bb01986a86241$var$sendSuccessAnalytics = (createAnalyticsEvent, currentEdition)=>{
    const analyticsSetSuccessEvent = createAnalyticsEvent({
        type: (0, $20c0bbc97fb7b0c7$export$8b4682bf35504518),
        action: (0, $20c0bbc97fb7b0c7$export$6d01cae610456af2),
        actionSubject: (0, $20c0bbc97fb7b0c7$export$17116f7e9ce47a15)
    });
    (0, $jMP2a.fireOperationalAnalytics)(analyticsSetSuccessEvent, `${(0, $20c0bbc97fb7b0c7$export$17116f7e9ce47a15)} ${(0, $20c0bbc97fb7b0c7$export$6d01cae610456af2)}`, {
        currentEdition: currentEdition
    });
};
const $bf5bb01986a86241$var$sendErrorAnalytics = (err, createAnalyticsEvent)=>{
    const analyticsSetFailEvent = createAnalyticsEvent({
        type: (0, $20c0bbc97fb7b0c7$export$8b4682bf35504518),
        action: (0, $20c0bbc97fb7b0c7$export$6a238c78062d3b8d),
        actionSubject: (0, $20c0bbc97fb7b0c7$export$17116f7e9ce47a15)
    });
    (0, $jMP2a.fireOperationalAnalytics)(analyticsSetFailEvent, `${(0, $20c0bbc97fb7b0c7$export$17116f7e9ce47a15)} ${(0, $20c0bbc97fb7b0c7$export$6a238c78062d3b8d)}`, {
        errorMessage: err.message
    });
};
const $bf5bb01986a86241$export$85f35a76872f3a15 = ({ currentEdition: currentEdition, product: product, shouldCheckImmediately: shouldCheckImmediately = false })=>{
    const [hasBeenUpgradedFromFree, setHasBeenUpgradedFromFree] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        let intervalId;
        if (currentEdition === (0, $6WXNs.FREE_EDITION)) {
            const fetchUpdatedEdition = ()=>{
                // if upgraded then clear the interval
                (0, $aX8d7.fetchSiteEdition)(product).then((siteEdition)=>{
                    $bf5bb01986a86241$var$sendSuccessAnalytics(createAnalyticsEvent, siteEdition);
                    setHasBeenUpgradedFromFree(siteEdition === (0, $6WXNs.STANDARD_EDITION));
                    if (siteEdition !== (0, $6WXNs.FREE_EDITION)) clearInterval(intervalId);
                }).catch((err)=>{
                    $bf5bb01986a86241$var$sendErrorAnalytics(err, createAnalyticsEvent);
                    clearInterval(intervalId);
                });
            };
            intervalId = setInterval(fetchUpdatedEdition, 300000);
            shouldCheckImmediately && fetchUpdatedEdition();
        }
        return ()=>clearInterval(intervalId);
    }, [
        createAnalyticsEvent,
        currentEdition,
        product,
        shouldCheckImmediately
    ]);
    return hasBeenUpgradedFromFree;
};
const $bf5bb01986a86241$export$f7ece173fbdc007 = (projectType, shouldRun, transactionAccountId)=>{
    const [hasMultiple, setHasMultiple] = (0, $eUqFw.useState)(null);
    const fetch = (0, $808rz.useCommerceFetch)();
    (0, $eUqFw.useEffect)(()=>{
        if (!shouldRun) return;
        if (!transactionAccountId) {
            setHasMultiple(false);
            return;
        }
        (async ()=>{
            const entitlements = await (0, $ecLYJ.fetchEntitlementsFromSearch)(fetch, transactionAccountId);
            const productName = (0, $5mjno.getOfferingProductKey)(projectType);
            const matchingProducts = entitlements.map(({ offering: offering })=>offering.product.name).filter((name)=>name === productName);
            setHasMultiple(matchingProducts.length > 1);
        })();
    }, [
        fetch,
        projectType,
        shouldRun,
        transactionAccountId
    ]);
    return {
        isLoading: hasMultiple === null,
        hasMultiple: hasMultiple
    };
};

});
parcelRegister("ecLYJ", function(module, exports) {

$parcel$export(module.exports, "fetchEntitlementsFromSearch", () => $a577673e1250addb$export$fa863ff60779c288);

var $eUqFw = parcelRequire("eUqFw");

var $808rz = parcelRequire("808rz");

var $c6fJL = parcelRequire("c6fJL");
var $3efrb = parcelRequire("3efrb");
var $cJx1n = parcelRequire("cJx1n");
const $a577673e1250addb$export$48314f791897fe3f = `${(0, $db4c3c7395dbf7e9$export$91e8019c72e4e6d)}/ccp/api/v1/search`;
const $a577673e1250addb$export$b7c315373fafd78a = `${(0, $db4c3c7395dbf7e9$export$91e8019c72e4e6d)}/ccp/api/v1/entitlements`;
const $a577673e1250addb$export$fa863ff60779c288 = async (fetch, txaId)=>{
    const response = await (0, $3efrb.rejectOnHttpError)('entitlements-search', fetch($a577673e1250addb$export$48314f791897fe3f, {
        method: 'post',
        headers: {
            'X-transaction-account': txaId,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            payload: {
                query: {
                    term: {
                        transactionAccountId: txaId
                    }
                }
            },
            class: 'entitlement',
            pageSize: 50,
            expand: [
                'subscriptionId',
                'offeringKey',
                'offeringKey.productKey',
                'subscriptionId.pricingPlanId',
                'order.itemId'
            ]
        })
    }));
    return (await response.json()).results;
};
const $a577673e1250addb$export$47f26df0e0174a68 = (txaId)=>{
    const fetch = (0, $808rz.useCommerceFetch)();
    return (0, $cJx1n.useFetchService)((0, $eUqFw.useCallback)(()=>$a577673e1250addb$export$fa863ff60779c288(fetch, txaId), [
        fetch,
        txaId
    ]));
};
const $a577673e1250addb$export$2ed44c73ffe1a0b9 = async (fetch, txaId, entitlementId)=>{
    const response = await (0, $3efrb.rejectOnHttpError)('entitlements-search', fetch($a577673e1250addb$export$48314f791897fe3f, {
        method: 'post',
        headers: {
            'X-transaction-account': txaId,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            payload: {
                query: {
                    term: {
                        entitlementId: entitlementId
                    }
                }
            },
            class: 'entitlement',
            expand: [
                'subscriptionId'
            ]
        })
    }));
    return (await response.json()).results[0];
};
const $a577673e1250addb$export$46ba615f4904929c = (txaId)=>{
    const fetch = (0, $808rz.useCommerceFetch)();
    return (0, $cJx1n.useService)((0, $eUqFw.useCallback)((entitlementId)=>$a577673e1250addb$export$2ed44c73ffe1a0b9(fetch, txaId, entitlementId), [
        fetch,
        txaId
    ]));
};
const $a577673e1250addb$export$c37c3206d7762a15 = async (fetch, txaId, entitlementId)=>{
    const response = await (0, $3efrb.rejectOnHttpError)('entitlements-details', fetch(`${$a577673e1250addb$export$b7c315373fafd78a}/${entitlementId}/details`, {
        method: 'GET',
        headers: {
            'X-transaction-account': txaId,
            'Content-Type': 'application/json'
        }
    }));
    return await response.json();
};
const $a577673e1250addb$export$f055f8819f196bf7 = (txaId)=>{
    const fetch = (0, $808rz.useCommerceFetch)();
    return (0, $cJx1n.useService)((0, $eUqFw.useCallback)((entitlementId)=>$a577673e1250addb$export$c37c3206d7762a15(fetch, txaId, entitlementId), [
        fetch,
        txaId
    ]));
};
const $a577673e1250addb$export$819e870252438a5 = async (fetch, txaId, entitlementId, prevVersion, retryInterval = 2500, maxRetries = 8)=>{
    const response = await (0, $c6fJL.autoRetry)(()=>$a577673e1250addb$export$2ed44c73ffe1a0b9(fetch, txaId, entitlementId), (data)=>data.version <= prevVersion, retryInterval, maxRetries);
    if (response.version <= prevVersion) throw new (0, $3efrb.HttpResponseError)('entitlement-poll', 504, // timeout code
    `Polling for entitlement "${entitlementId}" update timed out after ${maxRetries} retires`);
};

});
// top level domain should have a stargate proxy under this path
// see https://developer.atlassian.com/platform/stargate/concepts/domains/
const $db4c3c7395dbf7e9$export$91e8019c72e4e6d = `/gateway/api`;

parcelRegister("808rz", function(module, exports) {

$parcel$export(module.exports, "useCommerceFetch", () => $5d34df94d5f6faa4$export$5f844fc0012b62a);

var $eUqFw = parcelRequire("eUqFw");

var $3efrb = parcelRequire("3efrb");

var $j0cg6 = parcelRequire("j0cg6");

var $eeavm = parcelRequire("eeavm");

var $gVTxX = parcelRequire("gVTxX");

var $b66Ew = parcelRequire("b66Ew");
const $5d34df94d5f6faa4$export$5f844fc0012b62a = ()=>{
    const commerceContextFetch = (0, $gVTxX.useCommerceOverride)(fetch);
    const dispatchSentryException = (0, $j0cg6.useSentryExceptionDispatch)();
    return (0, $eUqFw.useCallback)(async (...args)=>{
        const [fetchInput] = args;
        const sanitizedUrl = (0, $eeavm.sanitizeUrlString)((0, $b66Ew.getRequestUrl)(fetchInput));
        try {
            const response = await commerceContextFetch(...args);
            if (response.status >= 400) dispatchSentryException({
                exception: new Error(`Status: ${response.status}\nURL: ${sanitizedUrl}`)
            });
            return response;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
            const oldErrorMessage = (()=>{
                if (error instanceof Error) {
                    var _error$stack;
                    return (_error$stack = error.stack) !== null && _error$stack !== void 0 ? _error$stack : error.toString();
                } else return JSON.stringify(error);
            })();
            const newErrorMessage = `An error occurred when fetching from ${sanitizedUrl}\n\n ${oldErrorMessage}`;
            const wrappedError = new Error(newErrorMessage);
            dispatchSentryException({
                exception: wrappedError
            });
            throw error;
        }
    }, [
        commerceContextFetch,
        dispatchSentryException
    ]);
};
const $5d34df94d5f6faa4$export$2eeff918208c7909 = (request, dispatchSentryException)=>request.catch((error)=>{
        // reportHttpError doesn't dispatch url as HttpResponseError has a resource name in the message
        if (error instanceof (0, $3efrb.HttpResponseError)) dispatchSentryException({
            exception: error
        });
        const oldErrorMessage = (()=>{
            if (error instanceof Error) {
                var _error$stack2;
                return (_error$stack2 = error.stack) !== null && _error$stack2 !== void 0 ? _error$stack2 : error.toString();
            } else return JSON.stringify(error);
        })();
        const newErrorMessage = `An error occurred when fetching data\n\n ${oldErrorMessage}`;
        dispatchSentryException({
            exception: new Error(newErrorMessage)
        });
        return error;
    });

});
parcelRegister("3efrb", function(module, exports) {

$parcel$export(module.exports, "HttpResponseError", () => $01bbf96cebd1b172$export$d2f2761cbe9cebf2);
$parcel$export(module.exports, "rejectOnHttpError", () => $01bbf96cebd1b172$export$a4c208475de70990);
class $01bbf96cebd1b172$export$d2f2761cbe9cebf2 extends Error {
    constructor(resourceName, statusCode, body){
        super(`Unable to fetch ${resourceName}, status: ${statusCode}`);
        this.name = 'HttpResponseError';
        this.statusCode = statusCode;
        this.body = body;
        // necessary as Subclassing Error needs special treatment in typescript for some compilation targets
        //https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $01bbf96cebd1b172$export$d2f2761cbe9cebf2.prototype);
    }
}
const $01bbf96cebd1b172$export$a4c208475de70990 = async (resourceName, response)=>{
    const res = await response;
    if (res.ok) return response;
    throw new $01bbf96cebd1b172$export$d2f2761cbe9cebf2(resourceName, res.status, // ignore error if there is no body,
    // there is no way to check if body is set as https://developer.mozilla.org/en-US/docs/Web/API/Body/bodyUsed is not supported by many browsers
    await res.json().catch(()=>undefined));
};

});

parcelRegister("j0cg6", function(module, exports) {

$parcel$export(module.exports, "useSentryExceptionDispatch", () => $dd5786c28467c183$export$cf4d833c52e18bed);

var $l3D0e = parcelRequire("l3D0e");

var $kKBSo = parcelRequire("kKBSo");

var $4MjVD = parcelRequire("4MjVD");
const { useBreadcrumbedEventDispatch: $dd5786c28467c183$export$3c3f21d4489e178a } = (0, $l3D0e.internalGasV3UIEventChannel);
const { useEventDispatch: $dd5786c28467c183$export$5e75c4fb0a07e6f4 } = (0, $l3D0e.internalGasV3ScreenEventChannel);
const { useBreadcrumbedEventDispatch: $dd5786c28467c183$export$eb1dac57abae25e8 } = (0, $l3D0e.internalGasV3TrackEventChannel);
const { useBreadcrumbedEventDispatch: $dd5786c28467c183$export$ab6d20b2228c09c6 } = (0, $l3D0e.internalGasV3OperationalEventChannel);
const { useBreadcrumbedEventDispatch: $dd5786c28467c183$export$2f592e355f772f5d } = (0, $l3D0e.internalMetalChannel);
const { useBreadcrumbedEventDispatch: $dd5786c28467c183$export$cf4d833c52e18bed } = (0, $l3D0e.internalSentryExceptionChannel);
const $dd5786c28467c183$export$8eb9a37a282b8ea6 = (0, $kKBSo.createAtlaskitToEventChannelRepackager)($dd5786c28467c183$export$3c3f21d4489e178a);
const { Listener: $dd5786c28467c183$export$d6cab26720f11779 } = (0, $l3D0e.breadcrumbMountedEventChannel);
const $dd5786c28467c183$export$794ea2871d096951 = (Component, name, attributes)=>(0, $4MjVD.withBreadcrumb)(Component, (0, $l3D0e.Breadcrumb), name, attributes);

});
parcelRegister("l3D0e", function(module, exports) {

$parcel$export(module.exports, "breadcrumbMountedEventChannel", () => $f54821e8da449c09$export$1622e7b9340efb0);
$parcel$export(module.exports, "Breadcrumb", () => $f54821e8da449c09$export$dabcc1ec9dd9d1cc);
$parcel$export(module.exports, "internalGasV3UIEventChannel", () => $f54821e8da449c09$export$b7973f9532f3f87f);
$parcel$export(module.exports, "internalGasV3ScreenEventChannel", () => $f54821e8da449c09$export$5a78c7e669ed705e);
$parcel$export(module.exports, "internalGasV3TrackEventChannel", () => $f54821e8da449c09$export$90a2fbbf51eb525f);
$parcel$export(module.exports, "internalGasV3OperationalEventChannel", () => $f54821e8da449c09$export$c70a8fa9e6b52c91);
$parcel$export(module.exports, "internalMetalChannel", () => $f54821e8da449c09$export$7d2454cf2c24f280);
$parcel$export(module.exports, "internalSentryExceptionChannel", () => $f54821e8da449c09$export$d9101fe70b7457a1);

var $4MjVD = parcelRequire("4MjVD");

var $3Vb2Y = parcelRequire("3Vb2Y");
const $f54821e8da449c09$var$breadcrumbAPI = (0, $4MjVD.createBreadcrumbAPI)();
const { breadcrumbMountedEventChannel: $f54821e8da449c09$export$1622e7b9340efb0, Breadcrumb: $f54821e8da449c09$export$dabcc1ec9dd9d1cc, useGetBreadcrumbs: $f54821e8da449c09$export$a841c408695b0137 } = $f54821e8da449c09$var$breadcrumbAPI;
const $f54821e8da449c09$export$58a908b728d2cddc = (0, $3Vb2Y.createCatchingEventChannel)();
const $f54821e8da449c09$export$34eb9485fd3a664a = (0, $3Vb2Y.createCatchingEventChannel)();
const $f54821e8da449c09$export$fb5e587076f78057 = (0, $3Vb2Y.createCatchingEventChannel)();
const $f54821e8da449c09$export$f92d259194a988f8 = (0, $3Vb2Y.createCatchingEventChannel)();
const $f54821e8da449c09$export$1dc5cea18df48a8 = (0, $3Vb2Y.createCatchingEventChannel)();
const $f54821e8da449c09$export$d9c23c680d73705d = (0, $3Vb2Y.createCatchingEventChannel)();
const $f54821e8da449c09$export$b7973f9532f3f87f = (0, $4MjVD.createBreadcrumbedEventChannel)($f54821e8da449c09$var$breadcrumbAPI, (0, $3Vb2Y.createCatchingEventChannel));
const $f54821e8da449c09$export$5a78c7e669ed705e = (0, $3Vb2Y.createCatchingEventChannel)();
const $f54821e8da449c09$export$90a2fbbf51eb525f = (0, $4MjVD.createBreadcrumbedEventChannel)($f54821e8da449c09$var$breadcrumbAPI, (0, $3Vb2Y.createCatchingEventChannel));
const $f54821e8da449c09$export$c70a8fa9e6b52c91 = (0, $4MjVD.createBreadcrumbedEventChannel)($f54821e8da449c09$var$breadcrumbAPI, (0, $3Vb2Y.createCatchingEventChannel));
const $f54821e8da449c09$export$7d2454cf2c24f280 = (0, $4MjVD.createBreadcrumbedEventChannel)($f54821e8da449c09$var$breadcrumbAPI, (0, $3Vb2Y.createCatchingEventChannel));
const $f54821e8da449c09$export$d9101fe70b7457a1 = (0, $4MjVD.createBreadcrumbedEventChannel)($f54821e8da449c09$var$breadcrumbAPI, (0, $3Vb2Y.createCatchingEventChannel));

});
parcelRegister("4MjVD", function(module, exports) {

$parcel$export(module.exports, "createBreadcrumbAPI", () => $37ab1a8ab9945ce2$export$783e5d823c500873);
$parcel$export(module.exports, "createBreadcrumbedEventChannel", () => $37ab1a8ab9945ce2$export$d3653322274df895);
$parcel$export(module.exports, "withBreadcrumb", () => $37ab1a8ab9945ce2$export$794ea2871d096951);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $3Vb2Y = parcelRequire("3Vb2Y");
const $37ab1a8ab9945ce2$var$emptyObject = {};
const $37ab1a8ab9945ce2$export$783e5d823c500873 = ()=>{
    const context = /*#__PURE__*/ (0, $eUqFw.createContext)(()=>undefined);
    const useGetBreadcrumbs = ()=>(0, $eUqFw.useContext)(context);
    const breadcrumbMountedEventChannel = (0, $3Vb2Y.createEventChannel)();
    const { useEventDispatch: useEventDispatch } = breadcrumbMountedEventChannel;
    const EmitEventOnMount = ({ name: name, getMountedBreadcrumbPayload: getMountedBreadcrumbPayload })=>{
        const eventDispatch = useEventDispatch();
        (0, $eUqFw.useEffect)(()=>{
            // Should always be defined at this point.
            eventDispatch(getMountedBreadcrumbPayload());
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            name
        ]);
        return null;
    };
    const Breadcrumb = ({ children: children, ...breadcrumbPayload })=>{
        const getParentBreadcrumbs = useGetBreadcrumbs();
        // TODO: Type inference doesn't seem to understand that children and name are never a part of breadcrumbPayload. Investigate and fix.
        const castBreadcrumbPayload = breadcrumbPayload;
        // Prevents breadcrumb callback from being recreated everytime props change/every-render
        const breadcrumbRef = (0, $eUqFw.useRef)(castBreadcrumbPayload);
        (0, $eUqFw.useLayoutEffect)(()=>{
            // Ensures that the breadcrumb only updates when it component is mounted
            breadcrumbRef.current = castBreadcrumbPayload;
        });
        // TODO: Memoize this in the future?
        const getMountedBreadcrumbPayload = (0, $eUqFw.useCallback)(()=>{
            var _getParentBreadcrumbs, _getParentBreadcrumbs2;
            return {
                breadcrumbs: [
                    ...(_getParentBreadcrumbs = (_getParentBreadcrumbs2 = getParentBreadcrumbs()) === null || _getParentBreadcrumbs2 === void 0 ? void 0 : _getParentBreadcrumbs2.breadcrumbs) !== null && _getParentBreadcrumbs !== void 0 ? _getParentBreadcrumbs : [],
                    breadcrumbRef.current
                ],
                payload: breadcrumbRef.current
            };
        }, [
            getParentBreadcrumbs
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(EmitEventOnMount, {
            name: breadcrumbPayload.name,
            getMountedBreadcrumbPayload: getMountedBreadcrumbPayload
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(context.Provider, {
            value: getMountedBreadcrumbPayload
        }, children));
    };
    return {
        breadcrumbMountedEventChannel: /**
     * An event channel whos event represents that a breadcrumb was mounted
     */ breadcrumbMountedEventChannel,
        Breadcrumb: Breadcrumb,
        useGetBreadcrumbs: useGetBreadcrumbs
    };
};
const $37ab1a8ab9945ce2$export$d3653322274df895 = ({ useGetBreadcrumbs: useGetBreadcrumbs }, createEventChannelFn = (0, $3Vb2Y.createEventChannel))=>{
    const { Listener: Listener, useEventDispatch: useEventDispatch } = createEventChannelFn();
    const useBreadcrumbedEventDispatch = ()=>{
        const eventDispatch = useEventDispatch();
        const getParentBreadcrumbs = useGetBreadcrumbs();
        const breadcrumbedEventDispatch = (0, $eUqFw.useCallback)((payload)=>{
            var _getParentBreadcrumbs3, _getParentBreadcrumbs4;
            return eventDispatch({
                breadcrumbs: (_getParentBreadcrumbs3 = (_getParentBreadcrumbs4 = getParentBreadcrumbs()) === null || _getParentBreadcrumbs4 === void 0 ? void 0 : _getParentBreadcrumbs4.breadcrumbs) !== null && _getParentBreadcrumbs3 !== void 0 ? _getParentBreadcrumbs3 : [],
                payload: payload
            });
        }, [
            getParentBreadcrumbs,
            eventDispatch
        ]);
        return breadcrumbedEventDispatch;
    };
    return {
        Listener: Listener,
        useEventDispatch: useEventDispatch,
        useBreadcrumbedEventDispatch: useBreadcrumbedEventDispatch
    };
};
const $37ab1a8ab9945ce2$export$794ea2871d096951 = (Component, Breadcrumb, name, // TODO: Fix up this type
breadcrumbFields = $37ab1a8ab9945ce2$var$emptyObject)=>{
    const ComponentWithBreadcrumb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Breadcrumb, (0, $kU09D.default)({}, breadcrumbFields, {
            name: name
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props));
    return ComponentWithBreadcrumb;
};

});
parcelRegister("3Vb2Y", function(module, exports) {

$parcel$export(module.exports, "createCatchingEventChannel", () => $2daf43a5050ffb93$export$5f3dbb5babc7e42e);
$parcel$export(module.exports, "createEventChannel", () => $2daf43a5050ffb93$export$7b182ad6fa711a33);

var $eUqFw = parcelRequire("eUqFw");
const $2daf43a5050ffb93$export$5f3dbb5babc7e42e = (defaultOnEventCallback)=>{
    const context = /*#__PURE__*/ (0, $eUqFw.createContext)(defaultOnEventCallback);
    const useEventDispatch = ()=>{
        const onEventCallback = (0, $eUqFw.useContext)(context);
        const fireEventCallback = (0, $eUqFw.useCallback)((event)=>{
            onEventCallback === null || onEventCallback === void 0 || onEventCallback(event);
        }, [
            onEventCallback
        ]);
        return fireEventCallback;
    };
    const EventCatcher = ({ onEvent: onEvent, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(context.Provider, {
            value: onEvent
        }, children);
    return {
        Listener: EventCatcher,
        useEventDispatch: useEventDispatch
    };
};
const $2daf43a5050ffb93$export$7b182ad6fa711a33 = ()=>{
    const catchingEventChannel = $2daf43a5050ffb93$export$5f3dbb5babc7e42e();
    const ListenerThatDoesntConsumeEvent = $2daf43a5050ffb93$export$a5fa32b3c7f79e99({
        from: catchingEventChannel.Listener,
        to: catchingEventChannel.useEventDispatch
    });
    return {
        Listener: ListenerThatDoesntConsumeEvent,
        useEventDispatch: catchingEventChannel.useEventDispatch
    };
};
const $2daf43a5050ffb93$export$21d0f08655d40180 = (...listenersToCombine)=>{
    const CombinedListener = ({ children: children, onEvent: onEvent })=>{
        let wrappedChildren = children;
        for (const ListenerToCombine of listenersToCombine)wrappedChildren = ListenerToCombine({
            onEvent: onEvent,
            children: wrappedChildren
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, wrappedChildren);
    };
    return CombinedListener;
};
const $2daf43a5050ffb93$export$9591aa59b8e3deeb = ({ from: inboundListenerValue, to: useOutboundEventDispatch, useTransformer: useTransformer })=>{
    const InboundListener = Array.isArray(inboundListenerValue) ? $2daf43a5050ffb93$export$21d0f08655d40180(...inboundListenerValue) : inboundListenerValue;
    const Transformer = ({ children: children, ...transformerProps })=>{
        const dispatchTransformedEvent = useOutboundEventDispatch();
        const transform = useTransformer(transformerProps);
        const transformFn = (0, $eUqFw.useCallback)((payload)=>{
            const transformed = transform(payload);
            dispatchTransformedEvent(transformed);
        }, [
            dispatchTransformedEvent,
            transform
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InboundListener, {
            onEvent: transformFn
        }, children);
    };
    return Transformer;
};
const $2daf43a5050ffb93$export$a5fa32b3c7f79e99 = ({ from: from, to: to })=>{
    const ListenerThatDoesntConsumeEvent = $2daf43a5050ffb93$export$9591aa59b8e3deeb({
        from: from,
        to: to,
        useTransformer: ({ onEvent: onEvent })=>(0, $eUqFw.useCallback)((payload)=>{
                onEvent(payload);
                return payload;
            }, [
                onEvent
            ])
    });
    return ListenerThatDoesntConsumeEvent;
};
const $2daf43a5050ffb93$export$6c91a1925c226122 = (Listener, filter)=>{
    const FilteredListener = ({ onEvent: onEvent, ...other })=>{
        const filteredOnEvent = (0, $eUqFw.useCallback)((eventPayload)=>{
            if (filter(eventPayload)) onEvent(eventPayload);
        }, [
            onEvent
        ]);
        return Listener({
            onEvent: filteredOnEvent,
            ...other
        });
    };
    return FilteredListener;
};
const $2daf43a5050ffb93$export$acca048df1683b81 = (children, components)=>{
    let wrappedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    for(let i = components.length - 1; i >= 0; i--){
        const { Listener: Listener, onEvent: onEvent } = components[i];
        wrappedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Listener, {
            onEvent: onEvent
        }, wrappedChildren);
    }
    return wrappedChildren;
};

});



parcelRegister("kKBSo", function(module, exports) {

$parcel$export(module.exports, "createAtlaskitToEventChannelRepackager", () => $f1b57bfdb9313da0$export$1ec809871e34d2f0);

var $eUqFw = parcelRequire("eUqFw");

var $jYVKV = parcelRequire("jYVKV");
var $bFzGY = parcelRequire("bFzGY");
const $f1b57bfdb9313da0$var$ATLASKIT_CHANNEL = 'atlaskit';
const $f1b57bfdb9313da0$export$b1e3a2222bb9a86d = (useEventDispatch, channel)=>{
    const RepackageAnalyticsNextEvent = ({ children: children, ...uiProperties })=>{
        const dispatchAnalytics = useEventDispatch();
        const repackageAtlaskitEvent = (0, $eUqFw.useCallback)((event)=>{
            dispatchAnalytics({
                ...uiProperties,
                ...event.payload,
                attributes: {
                    ...uiProperties.attributes,
                    ...event.payload.attributes
                }
            });
        }, [
            dispatchAnalytics,
            uiProperties
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
            channel: channel,
            onEvent: repackageAtlaskitEvent
        }, children);
    };
    return RepackageAnalyticsNextEvent;
};
const $f1b57bfdb9313da0$export$1ec809871e34d2f0 = (useEventDispatch)=>{
    const RepackageAtlaskitEvent = $f1b57bfdb9313da0$export$b1e3a2222bb9a86d(useEventDispatch, 'atlaskit');
    return RepackageAtlaskitEvent;
};
const $f1b57bfdb9313da0$export$ad0c43fbe23d07ab = (Listener, channel = $f1b57bfdb9313da0$var$ATLASKIT_CHANNEL)=>{
    return ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
        const fireAsAtlaskitEvent = (0, $eUqFw.useCallback)((payload)=>{
            createAnalyticsEvent(payload).fire(channel);
        }, [
            createAnalyticsEvent
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Listener, {
            onEvent: fireAsAtlaskitEvent
        }, children);
    };
};

});


parcelRegister("eeavm", function(module, exports) {

$parcel$export(module.exports, "sanitizeUrlString", () => $a5ba8581f8e2f489$export$ceb09b958e605eff);
/**
 * @param url The URL you want to sanitize
 * @returns A URL string without any user generated content (UGC) or PII (personally identifiable information). The URL will not necessarily be valid URL.
 */ const $a5ba8581f8e2f489$export$ceb09b958e605eff = (url)=>{
    // TODO: Should redact anything not from atlassian.com/atlassian.net/bitbucket.org/etc
    return url.replace(/\?.*$/, '');
};

});

parcelRegister("gVTxX", function(module, exports) {

$parcel$export(module.exports, "useCommerceOverride", () => $c53d0ea31ac77647$export$cf6f15ae0c6d3b84);

var $eUqFw = parcelRequire("eUqFw");

var $6ajUx = parcelRequire("6ajUx");
const $c53d0ea31ac77647$export$8d3ccdf5c3b9600a = ({ children: children, overrides: overrides })=>{
    const [registry] = (0, $eUqFw.useState)(()=>new Map(overrides));
    (0, $eUqFw.useEffect)(()=>{
        const callbacks = overrides.map(([subject, target])=>$c53d0ea31ac77647$export$87a46fc2314946e0(registry, subject, target));
        return ()=>callbacks.forEach((cb)=>cb());
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    overrides);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ajUx.overrideContext).Provider, {
        value: registry
    }, children);
};
const $c53d0ea31ac77647$export$edb6244a86733174 = ()=>(0, $eUqFw.useContext)((0, $6ajUx.overrideContext));
const $c53d0ea31ac77647$export$87a46fc2314946e0 = (registry, subject, override)=>{
    registry.set(subject, override);
    return ()=>{
        registry.delete(subject);
    };
};
const $c53d0ea31ac77647$export$9218bfcced62f524 = (registry, subject)=>{
    return registry.get(subject) || subject;
};
const $c53d0ea31ac77647$export$cf6f15ae0c6d3b84 = (subject)=>{
    const registry = $c53d0ea31ac77647$export$edb6244a86733174();
    return (registry || new Map()).get(subject) || subject;
};
const $c53d0ea31ac77647$export$ef191f4a42af511d = (subject, target)=>[
        subject,
        target
    ];

});
parcelRegister("6ajUx", function(module, exports) {

$parcel$export(module.exports, "overrideContext", () => $47d31f1f83fcd172$export$81b0387840a1a60c);
// eslint-disable-next-line import/no-extraneous-dependencies

var $eUqFw = parcelRequire("eUqFw");
const $47d31f1f83fcd172$export$81b0387840a1a60c = /*#__PURE__*/ (0, $eUqFw.createContext)(new Map());

});


parcelRegister("b66Ew", function(module, exports) {

$parcel$export(module.exports, "getRequestUrl", () => $81456a4ea232bcc0$export$14619c0eed01a470);
const $81456a4ea232bcc0$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;

});


parcelRegister("c6fJL", function(module, exports) {

$parcel$export(module.exports, "autoRetry", () => $4afd03606d92a6f4$export$d1e1b46258030985);
const $4afd03606d92a6f4$var$asyncWait = (interval)=>new Promise((resolve)=>setTimeout(resolve, interval));
const $4afd03606d92a6f4$export$d1e1b46258030985 = async (call, shouldRetry, interval = 1500, maxRetries = 3)=>{
    const tryCall = async (remainingRetries)=>{
        const result = await call();
        if (remainingRetries === 0 || !shouldRetry(result)) return result;
        await $4afd03606d92a6f4$var$asyncWait(interval);
        return tryCall(remainingRetries - 1);
    };
    return tryCall(maxRetries);
};

});

parcelRegister("cJx1n", function(module, exports) {

$parcel$export(module.exports, "useService", () => $c3c567d1bbcf8d70$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useFetchService", () => $c3c567d1bbcf8d70$export$ff7e5879ade03276);
// eslint-disable-next-line import/no-extraneous-dependencies

var $eUqFw = parcelRequire("eUqFw");
const $c3c567d1bbcf8d70$export$6de4685a6c88b4e9 = (request, initialState = {
    loading: false,
    data: undefined,
    error: undefined
})=>{
    const [state, setState] = (0, $eUqFw.useState)(initialState);
    const fetchData = (0, $eUqFw.useCallback)(async (...requestArgs)=>{
        setState({
            loading: true,
            data: undefined,
            error: undefined
        });
        try {
            const data = await request(...requestArgs);
            setState({
                loading: false,
                data: data,
                error: undefined
            });
            return data;
        } catch (error) {
            // Casting promise error to provided type. I assumes that the person that
            // provides types know that kind of type promise will return on reject.
            setState({
                loading: false,
                data: undefined,
                error: error
            });
            throw error;
        }
    }, [
        request
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            ...state,
            fetchData: fetchData
        }), [
        state,
        fetchData
    ]);
};
const $c3c567d1bbcf8d70$export$ff7e5879ade03276 = (request)=>{
    const service = $c3c567d1bbcf8d70$export$6de4685a6c88b4e9(request, {
        loading: true,
        data: undefined,
        error: undefined
    });
    const { fetchData: fetchData } = service;
    (0, $eUqFw.useEffect)(()=>{
        // on error promise will be resolved to undefined, error instance available in state
        // eslint-disable-next-line no-console
        fetchData().catch((error)=>console.warn(error));
    }, [
        fetchData
    ]);
    return (0, $eUqFw.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            refresh: ()=>fetchData()
        };
    }, [
        service
    ]);
};
const $c3c567d1bbcf8d70$export$18e513c1248d8ad5 = (request)=>{
    const service = $c3c567d1bbcf8d70$export$6de4685a6c88b4e9(request, {
        loading: false,
        data: undefined,
        error: undefined
    });
    return (0, $eUqFw.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            update: fetchData
        };
    }, [
        service
    ]);
};
const $c3c567d1bbcf8d70$export$d9765c5cd98039 = (request)=>{
    const service = $c3c567d1bbcf8d70$export$18e513c1248d8ad5(request);
    return (0, $eUqFw.useMemo)(()=>{
        const { update: update, ...state } = service;
        return {
            ...state,
            fetch: update
        };
    }, [
        service
    ]);
};
const $c3c567d1bbcf8d70$export$7077fee76310bc60 = (request)=>{
    const service = $c3c567d1bbcf8d70$export$6de4685a6c88b4e9(request);
    return (0, $eUqFw.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            create: fetchData
        };
    }, [
        service
    ]);
};

});


parcelRegister("5mjno", function(module, exports) {

$parcel$export(module.exports, "projectToProductKey", () => $d330be65f8a37258$export$91d312913437696b);
$parcel$export(module.exports, "isSupportedProjectType", () => $d330be65f8a37258$export$fa630a47d84fb39a);
$parcel$export(module.exports, "getUpgradeOnboardingCohort", () => $d330be65f8a37258$export$8dcc4580ff4c5896);
$parcel$export(module.exports, "fireUpgradeOnboardingExperimentExposure", () => $d330be65f8a37258$export$92cf59f952694fd9);
$parcel$export(module.exports, "isOnVariationForUpgradeOnboarding", () => $d330be65f8a37258$export$3d3583ae5aefed9b);
$parcel$export(module.exports, "projectTypeToApplicationKey", () => $d330be65f8a37258$export$83de85c996456cf6);
$parcel$export(module.exports, "getOfferingProductKey", () => $d330be65f8a37258$export$bd7b0000e7227cb5);

var $7ZZxN = parcelRequire("7ZZxN");

var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $jMP2a = parcelRequire("jMP2a");

const $d330be65f8a37258$export$37f449592e04a567 = [
    (0, $7ZZxN.SERVICE_DESK_PROJECT),
    (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT),
    (0, $7ZZxN.SOFTWARE_PROJECT)
];
const $d330be65f8a37258$export$91d312913437696b = (projectType)=>{
    const productKey = projectType && (0, $7ZZxN.projectTypeToCanonicalId)(projectType);
    return productKey === (0, $2edfd53057852e41$export$202f50ee62667e32) ? productKey : `${productKey}.ondemand`;
};
const $d330be65f8a37258$export$fa630a47d84fb39a = (value)=>{
    const projectType = (0, $7ZZxN.toProjectType)(value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return !!projectType && $d330be65f8a37258$export$37f449592e04a567.includes(projectType);
};
const $d330be65f8a37258$var$getFlagKey = (projectType)=>{
    let flagKey = 'unknown';
    if (projectType === (0, $7ZZxN.SOFTWARE_PROJECT)) flagKey = 'jsw_upgrade_onboarding_experiment';
    else if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) flagKey = 'jsm_upgrade_onboarding_experiment';
    else if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) flagKey = 'jpd_upgrade_onboarding_experiment';
    return flagKey;
};
const $d330be65f8a37258$export$8dcc4580ff4c5896 = (projectType)=>{
    let config;
    switch(projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            [config] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_upgrade_onboarding_experiment');
            break;
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            [config] = (0, $79xbN.UNSAFE_noExposureExp)('jsm_upgrade_onboarding_experiment');
            break;
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            [config] = (0, $79xbN.UNSAFE_noExposureExp)('jpd_upgrade_onboarding_experiment');
            break;
        default:
            [config] = (0, $79xbN.UNSAFE_noExposureExp)('unknown');
    }
    const cohort = config.get((0, $1Iui1.COHORT), (0, $1Iui1.NOT_ENROLLED));
    return cohort;
};
const $d330be65f8a37258$export$92cf59f952694fd9 = (createAnalyticsEvent, projectType, touchPoint)=>{
    let cohort;
    const flagKey = $d330be65f8a37258$var$getFlagKey(projectType);
    // send Statsig
    switch(projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            cohort = (0, $79xbN.expVal)('jsw_upgrade_onboarding_experiment', 'cohort', 'not-enrolled');
            break;
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            cohort = (0, $79xbN.expVal)('jsm_upgrade_onboarding_experiment', 'cohort', 'not-enrolled');
            break;
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            cohort = (0, $79xbN.expVal)('jpd_upgrade_onboarding_experiment', 'cohort', 'not-enrolled');
            break;
        default:
            cohort = (0, $79xbN.expVal)('unknown', 'cohort', 'not-enrolled');
    }
    // send GAS event
    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
        flagKey: flagKey,
        value: cohort,
        growthInitiative: 'transmuters',
        touchPoint: touchPoint
    });
};
const $d330be65f8a37258$export$3d3583ae5aefed9b = (projectType)=>$d330be65f8a37258$export$8dcc4580ff4c5896(projectType) === (0, $1Iui1.VARIATION);
const $d330be65f8a37258$export$83de85c996456cf6 = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return 0, $2edfd53057852e41$export$1346c9aa3cbb477d;
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 0, $2edfd53057852e41$export$c8c1c8c3f8ddba61;
        case 0, $7ZZxN.CORE_PROJECT:
            return 0, $2edfd53057852e41$export$db515c8cec1e6f79;
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return 0, $2edfd53057852e41$export$202f50ee62667e32;
        default:
            return 0, $2edfd53057852e41$export$db515c8cec1e6f79;
    }
};
const $d330be65f8a37258$export$bd7b0000e7227cb5 = (projectType)=>{
    let flagKey = 'unknown';
    if (projectType === (0, $7ZZxN.SOFTWARE_PROJECT)) flagKey = 'Jira Software (Cloud)';
    else if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) flagKey = 'Jira Service Management (Cloud)';
    else if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) flagKey = 'Jira Product Discovery';
    return flagKey;
};

});

parcelRegister("aX8d7", function(module, exports) {

$parcel$export(module.exports, "fetchSiteEdition", () => $8518ff8b1e826e26$export$fe20f49c478fbe19);

var $lRmyA = parcelRequire("lRmyA");

var $6WXNs = parcelRequire("6WXNs");
const $8518ff8b1e826e26$export$fe20f49c478fbe19 = async (product)=>{
    const url = '/rest/internal/latest/meta/edition';
    const response = await (0, $lRmyA.performGetRequest)(url);
    return (0, $6WXNs.editionKeyToEdition)(response[product]);
};

});


parcelRegister("1YPBj", function(module, exports) {

$parcel$export(module.exports, "getModalViewedProperty", () => $3fc516b14a2a7dad$export$f547f55b59eed5ba);
$parcel$export(module.exports, "getModalDismissedProperty", () => $3fc516b14a2a7dad$export$57bc178187add5f1);
$parcel$export(module.exports, "setModalViewedProperty", () => $3fc516b14a2a7dad$export$a0638a56ab0bfd5f);
$parcel$export(module.exports, "setModalDismissedProperty", () => $3fc516b14a2a7dad$export$a1fe8919c516346b);

var $48bs8 = parcelRequire("48bs8");

var $glT96 = parcelRequire("glT96");

const $3fc516b14a2a7dad$var$getViewedPropertyKey = (projectType)=>`${0, $20c0bbc97fb7b0c7$export$a842ad7d572fbccf}-${projectType}`;
const $3fc516b14a2a7dad$var$getDismissedPropertyKey = (projectType)=>`${0, $20c0bbc97fb7b0c7$export$58dd42d73affe399}-${projectType}`;
const $3fc516b14a2a7dad$export$f547f55b59eed5ba = async (createAnalyticsEvent, projectType, atlassianAccountId)=>{
    const propertyKey = $3fc516b14a2a7dad$var$getViewedPropertyKey(projectType);
    const property = await $3fc516b14a2a7dad$export$63ef76b19cf4a753(createAnalyticsEvent, atlassianAccountId, propertyKey);
    return !!property?.viewedOn;
};
const $3fc516b14a2a7dad$export$57bc178187add5f1 = async (createAnalyticsEvent, projectType, atlassianAccountId)=>{
    const propertyKey = $3fc516b14a2a7dad$var$getDismissedPropertyKey(projectType);
    const property = await $3fc516b14a2a7dad$export$63ef76b19cf4a753(createAnalyticsEvent, atlassianAccountId, propertyKey);
    return !!property?.dismissedOn;
};
const $3fc516b14a2a7dad$export$63ef76b19cf4a753 = (createAnalyticsEvent, atlassianAccountId, propertyKey)=>(0, $48bs8.getUserProperty)('', atlassianAccountId, propertyKey).then((res)=>{
        (0, $glT96.fireGetUserPropertySuccessEvent)(createAnalyticsEvent, res ?? {});
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return res ?? {};
    }).catch((e)=>{
        // 404 is returned if there is not user data set
        if (e.statusCode !== 404) (0, $glT96.fireGetUserPropertyFailEvent)(e, createAnalyticsEvent);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {};
    });
const $3fc516b14a2a7dad$export$a0638a56ab0bfd5f = (createAnalyticsEvent, projectType, atlassianAccountId)=>{
    const propertyKey = $3fc516b14a2a7dad$var$getViewedPropertyKey(projectType);
    const payload = {
        viewedOn: new Date().toJSON()
    };
    return $3fc516b14a2a7dad$var$setUserProperty(createAnalyticsEvent, atlassianAccountId, propertyKey, payload);
};
const $3fc516b14a2a7dad$export$a1fe8919c516346b = (createAnalyticsEvent, projectType, atlassianAccountId)=>{
    const propertyKey = $3fc516b14a2a7dad$var$getDismissedPropertyKey(projectType);
    const payload = {
        dismissedOn: new Date().toJSON()
    };
    return $3fc516b14a2a7dad$var$setUserProperty(createAnalyticsEvent, atlassianAccountId, propertyKey, payload);
};
const $3fc516b14a2a7dad$var$setUserProperty = (createAnalyticsEvent, atlassianAccountId, propertyKey, payload)=>(0, $48bs8.setUserProperties)('', atlassianAccountId, propertyKey, JSON.stringify({
        date: new Date().toJSON(),
        ...payload
    })).then(()=>{
        (0, $glT96.fireSetUserPropertySuccessEvent)(createAnalyticsEvent, payload);
    }).catch((e)=>{
        (0, $glT96.fireSetUserPropertyFailEvent)(e, createAnalyticsEvent, payload);
    });

});
parcelRegister("glT96", function(module, exports) {

$parcel$export(module.exports, "fireButtonAnalytics", () => $fabebecdbd451397$export$ac665b9f9662b94a);
$parcel$export(module.exports, "fireGetUserPropertyFailEvent", () => $fabebecdbd451397$export$dbcd67ae2733b450);
$parcel$export(module.exports, "fireGetUserPropertySuccessEvent", () => $fabebecdbd451397$export$2854f8e9cb03b29c);
$parcel$export(module.exports, "fireSetUserPropertyFailEvent", () => $fabebecdbd451397$export$ba21b6c2398a9c65);
$parcel$export(module.exports, "fireSetUserPropertySuccessEvent", () => $fabebecdbd451397$export$fc114645abe1e0a1);

var $jMP2a = parcelRequire("jMP2a");

const $fabebecdbd451397$export$ac665b9f9662b94a = (createAnalyticsEvent, actionSubjectId, attributes)=>{
    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    }), actionSubjectId, {
        upgradeOnboardingExperiment: true,
        ...attributes
    });
};
const $fabebecdbd451397$export$dbcd67ae2733b450 = (error, createAnalyticsEvent, payload)=>{
    const analyticsGetFailEvent = createAnalyticsEvent({
        type: (0, $20c0bbc97fb7b0c7$export$8b4682bf35504518),
        action: (0, $20c0bbc97fb7b0c7$export$6a238c78062d3b8d),
        actionSubject: (0, $20c0bbc97fb7b0c7$export$d094ee3fcda994eb)
    });
    (0, $jMP2a.fireOperationalAnalytics)(analyticsGetFailEvent, `${(0, $20c0bbc97fb7b0c7$export$d094ee3fcda994eb)} ${(0, $20c0bbc97fb7b0c7$export$6a238c78062d3b8d)}`, {
        growthFeature: (0, $20c0bbc97fb7b0c7$export$4ddf07b00a2c2bc4),
        errorMessage: error.message,
        errorStatus: error.statusCode,
        ...payload
    });
};
const $fabebecdbd451397$export$2854f8e9cb03b29c = (createAnalyticsEvent, payload)=>{
    const analyticsGetSuccessEvent = createAnalyticsEvent({
        type: (0, $20c0bbc97fb7b0c7$export$8b4682bf35504518),
        action: (0, $20c0bbc97fb7b0c7$export$6d01cae610456af2),
        actionSubject: (0, $20c0bbc97fb7b0c7$export$d094ee3fcda994eb)
    });
    (0, $jMP2a.fireOperationalAnalytics)(analyticsGetSuccessEvent, `${(0, $20c0bbc97fb7b0c7$export$d094ee3fcda994eb)} ${(0, $20c0bbc97fb7b0c7$export$6d01cae610456af2)}`, {
        growthFeature: (0, $20c0bbc97fb7b0c7$export$4ddf07b00a2c2bc4),
        ...payload
    });
};
const $fabebecdbd451397$export$ba21b6c2398a9c65 = (error, createAnalyticsEvent, payload)=>{
    const analyticsSetFailEvent = createAnalyticsEvent({
        type: (0, $20c0bbc97fb7b0c7$export$8b4682bf35504518),
        action: (0, $20c0bbc97fb7b0c7$export$6a238c78062d3b8d),
        actionSubject: (0, $20c0bbc97fb7b0c7$export$f3310dd86ae4284b)
    });
    (0, $jMP2a.fireOperationalAnalytics)(analyticsSetFailEvent, `${(0, $20c0bbc97fb7b0c7$export$f3310dd86ae4284b)} ${(0, $20c0bbc97fb7b0c7$export$6a238c78062d3b8d)}`, {
        growthFeature: (0, $20c0bbc97fb7b0c7$export$4ddf07b00a2c2bc4),
        errorMessage: error.message,
        errorStatus: error.statusCode,
        ...payload
    });
};
const $fabebecdbd451397$export$fc114645abe1e0a1 = (createAnalyticsEvent, payload)=>{
    const analyticsSetSuccessEvent = createAnalyticsEvent({
        type: (0, $20c0bbc97fb7b0c7$export$8b4682bf35504518),
        action: (0, $20c0bbc97fb7b0c7$export$6d01cae610456af2),
        actionSubject: (0, $20c0bbc97fb7b0c7$export$f3310dd86ae4284b)
    });
    (0, $jMP2a.fireOperationalAnalytics)(analyticsSetSuccessEvent, `${(0, $20c0bbc97fb7b0c7$export$f3310dd86ae4284b)} ${(0, $20c0bbc97fb7b0c7$export$6d01cae610456af2)}`, {
        growthFeature: (0, $20c0bbc97fb7b0c7$export$4ddf07b00a2c2bc4),
        ...payload
    });
};

});


parcelRegister("33DwA", function(module, exports) {

$parcel$export(module.exports, "ExperimentContainer", () => $a060b8a8a65d9016$export$23fe65b0d989f11f);

var $eUqFw = parcelRequire("eUqFw");

var $kpmC0 = parcelRequire("kpmC0");

var $bFzGY = parcelRequire("bFzGY");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");

var $gd0Sp = parcelRequire("gd0Sp");

var $85KBV = parcelRequire("85KBV");
var $3tHIq = parcelRequire("3tHIq");
var $iYz0W = parcelRequire("iYz0W");

var $P5vz8 = parcelRequire("P5vz8");

var $1YPBj = parcelRequire("1YPBj");

var $5mjno = parcelRequire("5mjno");

var $5q6M0 = parcelRequire("5q6M0");

var $jlZul = parcelRequire("jlZul");

var $bWelf = parcelRequire("bWelf");
const $a060b8a8a65d9016$export$23fe65b0d989f11f = ({ projectType: projectType, addPaymentMethodRef: addPaymentMethodRef, transactionAccountId: transactionAccountId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eUqFw.useState)(false);
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId, appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const { showFlag: showFlag } = (0, $5q6M0.useRefreshFlag)(projectType);
    const isVariation = (0, $5mjno.isOnVariationForUpgradeOnboarding)(projectType);
    const editionFromTenantContext = (0, $6WXNs.getEdition)((0, $eIp1n.getApplicationForProject)(projectType), appEditions);
    const product = (0, $5mjno.projectTypeToApplicationKey)(projectType);
    const isUpgradedInCurrentSession = (0, $3tHIq.useHasBeenUpgradedFromFree)({
        currentEdition: editionFromTenantContext,
        product: product,
        shouldCheckImmediately: true
    });
    const { hasMessageStarted: isEnrolledToEPMessage, setEpMessageStarted: setEpMessageStarted, stopMessage: stopMessage } = (0, $P5vz8.useEPMessagesForCoordination)(projectType);
    // determine if the user is eligible to see the modal regardless if we are on control or variation
    const isEligible = addPaymentMethodRef && isEnrolledToEPMessage;
    // only actually show the modal if we are on variation
    const showModal = isEligible && isVariation;
    const { isCollapsed: isCollapsed } = (0, $kpmC0.useLeftSidebarState)();
    // the keyboard event expands the sidebar if it is collapsed so that the spotlight can correctly highlight the upgrade pill
    // updating the sidebar context did not expand/collapse the sidebar so we went this route
    (0, $eUqFw.useEffect)(()=>{
        isCollapsed && showModal && document.dispatchEvent(new KeyboardEvent('keydown', {
            key: '['
        }));
    }, [
        isCollapsed,
        showModal
    ]);
    // exposure event is in its own useEFfect cos if we bundle it with the showing of the flag, it will fire twice
    // once when the useEffect triggers and then again when the flag is shown
    (0, $eUqFw.useEffect)(()=>{
        isUpgradedInCurrentSession && (0, $5mjno.fireUpgradeOnboardingExperimentExposure)(createAnalyticsEvent, projectType, 'flag');
    }, [
        createAnalyticsEvent,
        isUpgradedInCurrentSession,
        projectType
    ]);
    (0, $eUqFw.useEffect)(()=>{
        isVariation && isUpgradedInCurrentSession && showFlag();
    }, [
        isVariation,
        isUpgradedInCurrentSession,
        showFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (async ()=>{
            // If we are already in standard, check EP if we were just recently upgraded
            if (!isUpgradedInCurrentSession && editionFromTenantContext === (0, $6WXNs.STANDARD_EDITION) && atlassianAccountId) {
                const hasUpgradedTraits = await (0, $85KBV.isUpgradedBasedOnTraits)(product, cloudId, transactionAccountId);
                if (hasUpgradedTraits) {
                    const wasModalViewed = await (0, $1YPBj.getModalViewedProperty)(createAnalyticsEvent, projectType, atlassianAccountId);
                    // we only check EP message if we have the traits set and
                    // the modal hasn't been shown before based on the user property
                    if (!wasModalViewed) setEpMessageStarted();
                }
            }
        })();
    }, [
        atlassianAccountId,
        cloudId,
        createAnalyticsEvent,
        editionFromTenantContext,
        isUpgradedInCurrentSession,
        product,
        projectType,
        setEpMessageStarted,
        transactionAccountId
    ]);
    const { shouldShow: shouldShowSpotlightOnLand, onModalViewed: onModalViewed, onModalDismissed: onModalDismissed, onClose: onSpotlightClose } = (0, $iYz0W.useShouldShowSpotlightOnLand)(projectType);
    // exposure event is in its own useEFfect cos if we bundle it with the showing of the modal, it will fire twice
    // once when the useEffect triggers and then again when the modal is shown
    (0, $eUqFw.useEffect)(()=>{
        // fire exposure event for both control and variation
        isEligible && (0, $5mjno.fireUpgradeOnboardingExperimentExposure)(createAnalyticsEvent, projectType, 'modal');
    }, [
        createAnalyticsEvent,
        isEligible,
        projectType
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // only show modal for variation
        showModal && onModalViewed();
    }, [
        onModalViewed,
        showModal
    ]);
    const showSpotlight = isVariation && (isSpotlightActive || shouldShowSpotlightOnLand);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, showModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bWelf.default), {
        onDismiss: ()=>{
            onModalDismissed();
            setIsSpotlightActive(true);
        },
        onClose: ()=>stopMessage(),
        addPaymentMethodRef: addPaymentMethodRef,
        projectType: projectType,
        transactionAccountId: transactionAccountId
    }), showSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jlZul.SpotlightPill), {
        onClose: ()=>{
            onSpotlightClose();
            setIsSpotlightActive(false);
        }
    }));
};

});
parcelRegister("iYz0W", function(module, exports) {

$parcel$export(module.exports, "useShouldShowSpotlightOnLand", () => $7968cccf38515776$export$ad036e7bdec5d911);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $5ge6s = parcelRequire("5ge6s");

var $bFzGY = parcelRequire("bFzGY");

var $jD3pk = parcelRequire("jD3pk");

var $3e9vj = parcelRequire("3e9vj");
var $gd0Sp = parcelRequire("gd0Sp");

var $1YPBj = parcelRequire("1YPBj");
const $7968cccf38515776$var$getEPMessageId = (environment, projectType)=>{
    const isProd = environment === 'prod';
    let epMessageId;
    if (projectType === (0, $7ZZxN.SOFTWARE_PROJECT)) epMessageId = isProd ? 'jsw-upgrade-onboarding-spotlight' : 'jsw-upgrade-onboarding-spotlight-stg';
    else if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) epMessageId = isProd ? 'jsm-upgrade-onboarding-spotlight' : 'jsm-upgrade-onboarding-spotlight-stg';
    else if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) epMessageId = isProd ? 'jpd-upgrade-onboarding-spotlight' : 'jpd-upgrade-onboarding-spotlight-stg';
    return epMessageId;
};
const $7968cccf38515776$export$ad036e7bdec5d911 = (projectType)=>{
    const environment = (0, $3e9vj.useEnvironment)();
    const [shouldShow, setShouldShow] = (0, $eUqFw.useState)(false);
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const coordinationClient = (0, $eUqFw.useMemo)(()=>new (0, $5ge6s.CoordinationClient)(cloudId, '/gateway/api', false, orgId), [
        cloudId,
        orgId
    ]);
    const epMessageId = $7968cccf38515776$var$getEPMessageId(environment, projectType);
    (0, $eUqFw.useEffect)(()=>{
        if (!atlassianAccountId || !epMessageId) return;
        Promise.all([
            (0, $1YPBj.getModalViewedProperty)(createAnalyticsEvent, projectType, atlassianAccountId),
            (0, $1YPBj.getModalDismissedProperty)(createAnalyticsEvent, projectType, atlassianAccountId)
        ]).then(async ([wasModalViewed, wasModalDismissed])=>{
            // we only check EP if the modal was shown but not dismissed
            if (wasModalViewed && !wasModalDismissed) {
                const started = await coordinationClient.start(epMessageId);
                setShouldShow(started);
            }
        });
    }, [
        atlassianAccountId,
        coordinationClient,
        createAnalyticsEvent,
        epMessageId,
        projectType
    ]);
    return {
        shouldShow: shouldShow,
        onModalViewed: (0, $eUqFw.useCallback)(()=>atlassianAccountId && (0, $1YPBj.setModalViewedProperty)(createAnalyticsEvent, projectType, atlassianAccountId), [
            atlassianAccountId,
            createAnalyticsEvent,
            projectType
        ]),
        onModalDismissed: (0, $eUqFw.useCallback)(()=>atlassianAccountId && (0, $1YPBj.setModalDismissedProperty)(createAnalyticsEvent, projectType, atlassianAccountId), [
            atlassianAccountId,
            createAnalyticsEvent,
            projectType
        ]),
        onClose: (0, $eUqFw.useCallback)(()=>{
            if (!epMessageId) return;
            setShouldShow(false);
            coordinationClient.stop(epMessageId);
        }, [
            coordinationClient,
            epMessageId
        ])
    };
};

});
parcelRegister("5ge6s", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $67d1cec28351d2e7$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $67d1cec28351d2e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hpAuL = parcelRequire("hpAuL");
var $8Voen = parcelRequire("8Voen");

var $e91YZ = parcelRequire("e91YZ");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $jD3pk = parcelRequire("jD3pk");
const $67d1cec28351d2e7$var$isSyntheticTenant = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';
class $67d1cec28351d2e7$export$580a2294c917898c extends (0, $8Voen.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = ''){
        const coordinationOptions = {
            enableChoreographer: (0, $1ybV0.ff)('post-office_enable_jira_choreographer')
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $67d1cec28351d2e7$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $1ybV0.ff)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) await super.stop(messageId);
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId);
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId);
    }
}
function $67d1cec28351d2e7$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const client = new $67d1cec28351d2e7$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hpAuL.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children);
}

});

parcelRegister("3e9vj", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $f75608ebab912e29$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $f75608ebab912e29$export$b0d8f74f433a09c9);

var $gd0Sp = parcelRequire("gd0Sp");
const $f75608ebab912e29$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $f75608ebab912e29$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext?.environment || $f75608ebab912e29$var$ENVIRONMENT.PROD;
};
const $f75608ebab912e29$export$b0d8f74f433a09c9 = ()=>{
    const env = $f75608ebab912e29$export$ea7ed2425832167d();
    return env === $f75608ebab912e29$var$ENVIRONMENT.STAGING || env === $f75608ebab912e29$var$ENVIRONMENT.DEV || env === $f75608ebab912e29$var$ENVIRONMENT.LOCAL;
};

});


parcelRegister("P5vz8", function(module, exports) {

$parcel$export(module.exports, "useEPMessagesForCoordination", () => $bffe395e3d003f4a$export$58087e9427f300c);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $5ge6s = parcelRequire("5ge6s");

var $jD3pk = parcelRequire("jD3pk");

var $3e9vj = parcelRequire("3e9vj");
var $gd0Sp = parcelRequire("gd0Sp");
const $bffe395e3d003f4a$var$getEPMessages = (environment, projectType)=>{
    const isProd = environment === 'prod';
    // [realtime message based on trait, realtime message targeting everyone, batch targeting everyone]
    let epMessageIds = [
        '',
        '',
        ''
    ];
    if (projectType === (0, $7ZZxN.SOFTWARE_PROJECT)) epMessageIds = isProd ? [
        'jsw-upgrade-onboarding-modal',
        'jsw-upgrade-onboarding',
        'jsw-upgrade-onboarding-batch'
    ] : [
        'jsw-upgrade-onboarding-modal-stg',
        'jsw-upgrade-onboarding-stg',
        'jsw-upgrade-onboarding-batch-stg'
    ];
    else if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) epMessageIds = isProd ? [
        'jsm-upgrade-onboarding-modal',
        'jsm-upgrade-onboarding',
        'jsm-upgrade-onboarding-batch'
    ] : [
        'jsm-upgrade-onboarding-modal-stg',
        'jsm-upgrade-onboarding-stg',
        'jsm-upgrade-onboarding-batch-stg'
    ];
    else if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) epMessageIds = isProd ? [
        'jpd-upgrade-onboarding-modal',
        'jpd-upgrade-onboarding',
        'jpd-upgrade-onboarding-batch'
    ] : [
        'jpd-upgrade-onboarding-modal-stg',
        'jpd-upgrade-onboarding-stg',
        'jpd-upgrade-onboarding-batch-stg'
    ];
    return epMessageIds;
};
const $bffe395e3d003f4a$export$58087e9427f300c = (projectType)=>{
    const environment = (0, $3e9vj.useEnvironment)();
    // null means coordination client has not yet determined what that message status is
    // true means the message has started and should be shown
    // false means the message should not be shown for any reason
    const [hasMessageStarted, setHasMessageStarted] = (0, $eUqFw.useState)(null);
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const coordinationClient = (0, $eUqFw.useMemo)(()=>new (0, $5ge6s.CoordinationClient)(cloudId, '/gateway/api', false, orgId), [
        cloudId,
        orgId
    ]);
    const [traitBasedMessage, realtimeMessage, batchMessage] = $bffe395e3d003f4a$var$getEPMessages(environment, projectType);
    const setEpMessageStarted = (0, $eUqFw.useCallback)(async ()=>{
        // check ep message based on traits
        let started = await coordinationClient.start(traitBasedMessage);
        // check ep message based on realtime audience targeting everyone
        // this exists for new sites
        if (!started) started = await coordinationClient.start(realtimeMessage);
        // check ep message based on batch audience targeting everyone
        // this is for backfilled sites
        if (!started) started = await coordinationClient.start(batchMessage);
        setHasMessageStarted(started);
    }, [
        coordinationClient,
        traitBasedMessage,
        realtimeMessage,
        batchMessage
    ]);
    const stopMessage = (0, $eUqFw.useCallback)(async ()=>{
        await coordinationClient.stop(traitBasedMessage);
        await coordinationClient.stop(realtimeMessage);
        await coordinationClient.stop(batchMessage);
        setHasMessageStarted(false);
    }, [
        coordinationClient,
        traitBasedMessage,
        realtimeMessage,
        batchMessage
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        setEpMessageStarted: setEpMessageStarted,
        stopMessage: stopMessage
    };
};
var $bffe395e3d003f4a$export$2e2bcd8739ae039 = $bffe395e3d003f4a$export$58087e9427f300c;

});

parcelRegister("5q6M0", function(module, exports) {

$parcel$export(module.exports, "useRefreshFlag", () => $423ed40b54f7bdc4$export$8ac2c6c7b37a6c1d);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $1n6uL = parcelRequire("1n6uL");

var $PdmhA = parcelRequire("PdmhA");

var $cCFSU = parcelRequire("cCFSU");
var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");


var $jfGhV = parcelRequire("jfGhV");

var $cWckF = parcelRequire("cWckF");
const $423ed40b54f7bdc4$var$SCREEN_NAME = 'upgradedFlag';
const $423ed40b54f7bdc4$var$UPGRADE_ONBOARDING_REFRESH_FLAG_ID = 'upgradeOnboardingRefresh';
const $423ed40b54f7bdc4$var$sendUIEvent = (createAnalyticsEvent)=>{
    const analyticsSetSuccessEvent = createAnalyticsEvent({
        type: (0, $20c0bbc97fb7b0c7$export$eb3c99601284633),
        action: (0, $20c0bbc97fb7b0c7$export$99eda8c92da59583),
        actionSubject: (0, $20c0bbc97fb7b0c7$export$9eee3f7eec5c9126),
        actionSubjectId: (0, $20c0bbc97fb7b0c7$export$5824144caaec3f1e)
    });
    return (0, $jMP2a.fireUIAnalytics)(analyticsSetSuccessEvent, (0, $20c0bbc97fb7b0c7$export$5824144caaec3f1e));
};
const $423ed40b54f7bdc4$export$8ac2c6c7b37a6c1d = (projectType)=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [flagVisible, setFlagVisible] = (0, $eUqFw.useState)(false);
    const flagId = (0, $eUqFw.useRef)();
    const doShowFlag = (0, $eUqFw.useCallback)(()=>{
        if (flagVisible) return;
        setFlagVisible(true);
        showFlag(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($423ed40b54f7bdc4$export$8638a8b79aec05e5, {
                projectType: projectType,
                onDismissed: ()=>flagId.current && dismissFlag(flagId.current)
            }));
    }, [
        flagVisible,
        showFlag,
        projectType,
        dismissFlag
    ]);
    return {
        showFlag: doShowFlag
    };
};
const $423ed40b54f7bdc4$export$8638a8b79aec05e5 = ({ projectType: projectType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClick = (0, $eUqFw.useCallback)(()=>{
        // this analytics event isn't 100 % reliable since it is
        // possible the page gets reloaded before the event get sent
        $423ed40b54f7bdc4$var$sendUIEvent(createAnalyticsEvent);
        // reload page
        window.location.reload();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: $423ed40b54f7bdc4$var$SCREEN_NAME,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1n6uL))), {
            primaryColor: `var(--ds-icon-accent-purple, ${(0, $PdmhA.P400)})`,
            label: formatMessage((0, $jfGhV.default).iconLabel)
        }),
        description: formatMessage((0, $jfGhV.default).contentText),
        id: (0, $eo17r.toFlagId)($423ed40b54f7bdc4$var$UPGRADE_ONBOARDING_REFRESH_FLAG_ID),
        title: formatMessage((0, $jfGhV.default).title, {
            product: (0, $cWckF.getApplicationName)(projectType)
        }),
        actions: [
            {
                content: formatMessage((0, $jfGhV.default).refreshPage),
                onClick: onClick
            }
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};

});
parcelRegister("cCFSU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59aa209343f0b13$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5L0Jp = parcelRequire("5L0Jp");

var $kQ0RL = parcelRequire("kQ0RL");
const $f59aa209343f0b13$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $f59aa209343f0b13$export$2e2bcd8739ae039 = $f59aa209343f0b13$var$AkFlag;

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintCommonFlag = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("aiVXY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cCYJs')
        ]);
        const value = parcelRequire('kbpOk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cCYJs")
    ]).then(()=>parcelRequire('kbpOk'));
}

});

parcelRegister("Tabui", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hkLGi');
        const value = parcelRequire('jkRT2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hkLGi").then(()=>parcelRequire('jkRT2'));
}

});



// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("jfGhV", function(module, exports) {

$parcel$export(module.exports, "default", () => $48e003abfc19b3df$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $48e003abfc19b3df$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "upgrade-onboarding-experiment.refresh-flag.title",
        "defaultMessage": "{product} has been upgraded to Standard"
    },
    contentText: {
        "id": "upgrade-onboarding-experiment.refresh-flag.content-text",
        "defaultMessage": "We need to refresh Jira to get you started with the Standard plan."
    },
    refreshPage: {
        "id": "upgrade-onboarding-experiment.refresh-flag.refresh-page",
        "defaultMessage": "Refresh Jira"
    },
    iconLabel: {
        "id": "upgrade-onboarding-experiment.refresh-flag.icon-label",
        "defaultMessage": "Refresh Jira"
    }
});

});

parcelRegister("cWckF", function(module, exports) {

$parcel$export(module.exports, "getApplicationName", () => $e6e400b94a9d2cb8$export$e248db7c9a3cd59);

var $7ZZxN = parcelRequire("7ZZxN");

var $6bYiA = parcelRequire("6bYiA");
const $e6e400b94a9d2cb8$export$e248db7c9a3cd59 = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return 'Jira';
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 0, $6bYiA.JIRA_SERVICE_MANAGEMENT_APP_NAME;
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return 0, $6bYiA.JIRA_PRODUCT_DISCOVERY_APP_NAME;
        default:
            throw new Error(`Unknown application type: ${projectType}`);
    }
};

});


parcelRegister("jlZul", function(module, exports) {

$parcel$export(module.exports, "SpotlightPill", () => $42b335b789e3612a$export$e6e01963a7dfc59);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");
var $bFzGY = parcelRequire("bFzGY");

var $aO9bw = parcelRequire("aO9bw");
var $8NdH4 = parcelRequire("8NdH4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");

var $glT96 = parcelRequire("glT96");


var $kWWrX = parcelRequire("kWWrX");
const $42b335b789e3612a$var$SOURCE_NAME = 'trialPillSpotlight';
const $42b335b789e3612a$export$e6e01963a7dfc59 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleClose = ()=>{
        (0, $glT96.fireButtonAnalytics)(createAnalyticsEvent, (0, $20c0bbc97fb7b0c7$export$4119d842f9fd3189), {});
        onClose();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8NdH4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            source: $42b335b789e3612a$var$SOURCE_NAME
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aO9bw.default), {
        actions: [
            {
                onClick: handleClose,
                text: formatMessage((0, $kWWrX.default).spotlightDismiss)
            }
        ],
        heading: formatMessage((0, $kWWrX.default).spotlightHeading),
        target: "edition-awareness-trial-pill",
        key: "edition-awareness-trial-pill",
        targetRadius: 16
    }, formatMessage((0, $kWWrX.default).spotlightBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};

});
parcelRegister("kWWrX", function(module, exports) {

$parcel$export(module.exports, "default", () => $99416cb1416e5ec8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $99416cb1416e5ec8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    spotlightDismiss: {
        "id": "upgrade-onboarding-experiment.spotlight.spotlight-dismiss",
        "defaultMessage": "Dismiss"
    },
    spotlightHeading: {
        "id": "upgrade-onboarding-experiment.spotlight.spotlight-heading",
        "defaultMessage": "Trial and plan info"
    },
    spotlightBody: {
        "id": "upgrade-onboarding-experiment.spotlight.spotlight-body",
        "defaultMessage": "See how many trial days you have left, and learn more about the Standard plan here."
    }
});

});


parcelRegister("bWelf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a162848db7ac7c0c$export$2e2bcd8739ae039);

var $edFOL = parcelRequire("edFOL");
var $a162848db7ac7c0c$export$2e2bcd8739ae039 = (0, $edFOL.UpgradeOnboardingModal);

});
parcelRegister("edFOL", function(module, exports) {

$parcel$export(module.exports, "UpgradeOnboardingModal", () => $d43778c537117d45$export$a776b7edc0cd41b2);

var $dO23g = parcelRequire("dO23g");

var $eUqFw = parcelRequire("eUqFw");

var $jkH4Q = parcelRequire("jkH4Q");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $aOw1G = parcelRequire("aOw1G");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $4q38b = parcelRequire("4q38b");

var $7ZZxN = parcelRequire("7ZZxN");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $glT96 = parcelRequire("glT96");

var $85KBV = parcelRequire("85KBV");

var $cfSGT = parcelRequire("cfSGT");

var $5mjno = parcelRequire("5mjno");

var $9Q2rB = parcelRequire("9Q2rB");

var $fMuUC = parcelRequire("fMuUC");

var $g2kkD = parcelRequire("g2kkD");
const $d43778c537117d45$var$SOURCE_NAME = 'upgradeOnboarding';
const $d43778c537117d45$export$a776b7edc0cd41b2 = ({ projectType: projectType, addPaymentMethodRef: addPaymentMethodRef, onDismiss: onDismiss, onClose: onCloseCallback, transactionAccountId: transactionAccountId })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(true);
    const [messageContent, setMessageContent] = (0, $eUqFw.useState)((0, $fMuUC.default).softwareAutoUpgradeDescription);
    const [headingContent, setHeadingContent] = (0, $eUqFw.useState)('');
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const { cloudId: cloudId, productEntitlementDetails: productEntitlementDetails } = (0, $gd0Sp.useTenantContext)();
    const data = (0, $iWLL0.useFragment)((0, $dO23g.default), addPaymentMethodRef);
    const product = (0, $5mjno.projectTypeToApplicationKey)(projectType);
    const trialEndTime = productEntitlementDetails?.[product]?.trialEndTime;
    const origin = new (0, $jkH4Q.default)({
        product: 'jira'
    });
    const isDarkMode = colorMode === 'dark';
    const redirectUrl = origin.addToUrl(data?.experienceUrl || '');
    const onClose = ()=>{
        setIsOpen(false);
        onCloseCallback?.();
        onDismiss();
    };
    const onClickAddPaymentDetailsLink = ()=>{
        (0, $glT96.fireButtonAnalytics)(createAnalyticsEvent, 'addPaymentDetails', {});
        setIsOpen(false);
        onCloseCallback?.();
    };
    const closeModal = ()=>{
        (0, $glT96.fireButtonAnalytics)(createAnalyticsEvent, 'dismissUpgradeOnboardingModal', {});
        onClose();
    };
    (0, $eUqFw.useEffect)(()=>{
        (async ()=>{
            let traits = await (0, $85KBV.fetchSiteTraits)(cloudId);
            const possibleTraits = new Set((0, $cfSGT.UPGRADE_ONBOARDING_PRODUCT_TRAIT_MAP).get(product));
            let foundTraits = traits.filter((trait)=>possibleTraits.has(trait.name));
            // for manual upgrade from billing console (CCP), the trait is recorded against the transactionAccountId
            if (foundTraits.length === 0 && transactionAccountId) {
                traits = await (0, $85KBV.fetchSiteTraits)(transactionAccountId);
                foundTraits = traits.filter((trait)=>possibleTraits.has(trait.name));
            }
            if (foundTraits.length >= 1) {
                // sort by date and get the latest upgrade trait. if its just one trait array doesn't change
                foundTraits.sort((a, b)=>new Date(b.value).getTime() - new Date(a.value).getTime());
                const isAutoUpgrade = foundTraits[0].name.includes('auto_upgrade');
                if (projectType === (0, $7ZZxN.SOFTWARE_PROJECT)) {
                    if (isAutoUpgrade) {
                        setHeadingContent(formatMessage((0, $fMuUC.default).headingAutoUpgrade));
                        setMessageContent((0, $fMuUC.default).softwareAutoUpgradeDescription);
                    } else {
                        setHeadingContent(formatMessage((0, $fMuUC.default).headingManualUpgrade, {
                            product: 'Jira'
                        }));
                        setMessageContent((0, $fMuUC.default).softwareManualUpgradeDescription);
                    }
                } else if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) {
                    if (isAutoUpgrade) {
                        setHeadingContent(formatMessage((0, $fMuUC.default).headingAutoUpgrade));
                        setMessageContent((0, $fMuUC.default).serviceDeskAutoUpgradeDescription);
                    } else {
                        setHeadingContent(formatMessage((0, $fMuUC.default).headingManualUpgrade, {
                            product: 'Jira Service Management'
                        }));
                        setMessageContent((0, $fMuUC.default).serviceDeskManualUpgradeDescription);
                    }
                } else if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) {
                    if (isAutoUpgrade) {
                        setHeadingContent(formatMessage((0, $fMuUC.default).headingAutoUpgrade));
                        setMessageContent((0, $fMuUC.default).productDiscoveryAutoUpgradeDescription);
                    } else {
                        setHeadingContent(formatMessage((0, $fMuUC.default).headingManualUpgrade, {
                            product: 'Jira Product Discovery'
                        }));
                        setMessageContent((0, $fMuUC.default).productDiscoveryManualUpgradeDescription);
                    }
                }
            }
        })();
    }, [
        cloudId,
        formatMessage,
        product,
        projectType,
        transactionAccountId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: $d43778c537117d45$var$SOURCE_NAME,
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose,
        width: 960,
        autoFocus: false,
        shouldScrollInViewport: true,
        testId: "upgrade-onboarding-experiment.ui.upgrade-onboarding-modal.upgrade-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            originProduct: 'jira',
            originIdGenerated: origin?.id
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d43778c537117d45$var$BodyContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d43778c537117d45$var$LeftBodyPanelStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $d43778c537117d45$var$TitleWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "large"
    }, headingContent))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $d43778c537117d45$var$DescriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), messageContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g2kkD.TimelineSection), {
        trialEndTime: trialEndTime
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d43778c537117d45$var$ButtonGroupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: closeModal
    }, formatMessage((0, $fMuUC.default).later)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "upgrade-onboarding-experiment.ui.upgrade-onboarding-modal.cta-button",
        appearance: "primary",
        href: redirectUrl,
        onClick: onClickAddPaymentDetailsLink,
        target: "_blank"
    }, formatMessage((0, $fMuUC.default).addPaymentDetails)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $d43778c537117d45$var$RightBodyPanelStyles,
            isDarkMode ? $d43778c537117d45$var$RightBodyPanelBackgroundDarkStyles : $d43778c537117d45$var$RightBodyPanelBackgroundStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Q2rB.Carousel), {
        projectType: projectType
    }))))));
};
var $d43778c537117d45$export$2e2bcd8739ae039 = $d43778c537117d45$export$a776b7edc0cd41b2;
const $d43778c537117d45$var$TitleWrapperStyles = (0, $1ZAYh.xcss)({
    marginBottom: "var(--ds-space-200, 16px)"
});
const $d43778c537117d45$var$BodyContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    position: 'relative'
});
const $d43778c537117d45$var$DescriptionStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.0',
    marginBottom: "var(--ds-space-100, 8px)",
    maxWidth: '382px'
});
const $d43778c537117d45$var$LeftBodyPanelStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '536px',
    justifyContent: 'space-between',
    flex: '1',
    flexBasis: '480px',
    padding: 'space.600',
    boxSizing: 'border-box',
    color: 'color.text'
});
const $d43778c537117d45$var$RightBodyPanelStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '536px',
    justifyContent: 'end',
    flex: '1',
    flexBasis: '480px',
    padding: 'space.500',
    boxSizing: 'border-box',
    color: 'color.text',
    borderTopLeftRadius: 'space.0',
    borderTopRightRadius: '3px',
    borderBottomRightRadius: '3px',
    borderBottomLeftRadius: 'space.0'
});
const $d43778c537117d45$var$RightBodyPanelBackgroundStyles = (0, $1ZAYh.xcss)({
    background: 'linear-gradient(84deg, #E9F2FF 0%, #F3F0FF 100%)'
});
const $d43778c537117d45$var$RightBodyPanelBackgroundDarkStyles = (0, $1ZAYh.xcss)({
    background: 'linear-gradient(84deg, #092957 0%, #2B2451 100%)'
});
const $d43778c537117d45$var$ButtonGroupContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    justifyContent: 'right',
    gap: 'space.150'
});

});
parcelRegister("dO23g", function(module, exports) {

$parcel$export(module.exports, "default", () => $f155fc8a360fc220$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cfb850a7175b8d63d4042a6a745b6a3e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f155fc8a360fc220$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_upgradeOnboardingExperiment_UpgradeOnboardingModal",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "experienceUrl"
        }
    ],
    "type": "CommerceExperienceCapability",
    "abstractKey": "__isCommerceExperienceCapability"
};
$f155fc8a360fc220$var$node.hash = "33c989c1d58b8c6208a2d186e1f942e8";
var $f155fc8a360fc220$export$2e2bcd8739ae039 = $f155fc8a360fc220$var$node;

});

parcelRegister("9Q2rB", function(module, exports) {

$parcel$export(module.exports, "Carousel", () => $8b76f2b498b3322b$export$144901db2ea8e967);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $j9fWg = parcelRequire("j9fWg");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $iFmgL = parcelRequire("iFmgL");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $7ZZxN = parcelRequire("7ZZxN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ejOe8 = parcelRequire("ejOe8");

var $bFzGY = parcelRequire("bFzGY");

var $1R3n5 = parcelRequire("1R3n5");

var $glT96 = parcelRequire("glT96");

var $bd5FY = parcelRequire("bd5FY");

var $iXOqR = parcelRequire("iXOqR");

var $iXX80 = parcelRequire("iXX80");

var $6Qne0 = parcelRequire("6Qne0");

var $9omrG = parcelRequire("9omrG");

var $7IOvW = parcelRequire("7IOvW");

var $ch24A = parcelRequire("ch24A");

var $bnk3q = parcelRequire("bnk3q");
const $8b76f2b498b3322b$export$144901db2ea8e967 = ({ projectType: projectType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [currentPage, setPage] = (0, $eUqFw.useState)(0);
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const slideContent = (0, $eUqFw.useMemo)(()=>{
        const slides = []; // add the specific image by project type
        if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) {
            slides.push({
                caption: formatMessage((0, $bnk3q.default).unlimitedAgents),
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                    xcss: $8b76f2b498b3322b$var$BenefitsImageStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6Qne0))),
                    alt: formatMessage((0, $bnk3q.default).jsmUserLimitImageAlt)
                }))
            });
            slides.push({
                caption: formatMessage((0, $bnk3q.default).increasedStorageLimits),
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                    xcss: $8b76f2b498b3322b$var$BenefitsImageStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($iXX80))),
                    alt: formatMessage((0, $bnk3q.default).jsmStorageLimitImageAlt)
                }))
            });
        } else if (projectType === (0, $7ZZxN.SOFTWARE_PROJECT)) {
            slides.push({
                caption: formatMessage((0, $bnk3q.default).unlimitedUsers),
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                    xcss: $8b76f2b498b3322b$var$BenefitsImageStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7IOvW))),
                    alt: formatMessage((0, $bnk3q.default).jswUserLimitImageAlt)
                }))
            });
            slides.push({
                caption: formatMessage((0, $bnk3q.default).increasedStorageLimits),
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                    xcss: $8b76f2b498b3322b$var$BenefitsImageStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9omrG))),
                    alt: formatMessage((0, $bnk3q.default).jswStorageLimitImageAlt)
                }))
            });
        } else if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) {
            slides.push({
                caption: formatMessage((0, $bnk3q.default).unlimitedCreators),
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                    xcss: $8b76f2b498b3322b$var$BenefitsImageStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($iXOqR))),
                    alt: formatMessage((0, $bnk3q.default).jpdUserLimitImageAlt)
                }))
            });
            slides.push({
                caption: formatMessage((0, $bnk3q.default).increasedStorageLimits),
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                    xcss: $8b76f2b498b3322b$var$BenefitsImageStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($bd5FY))),
                    alt: formatMessage((0, $bnk3q.default).jpdStorageLimitImageAlt)
                }))
            });
        }
        if (isSiteAdmin) slides.push({
            caption: formatMessage((0, $bnk3q.default).standardPlanFeatures),
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ch24A.BenefitsSlide), {
                projectType: projectType
            })
        });
        return slides;
    }, [
        formatMessage,
        isSiteAdmin,
        projectType
    ]);
    const numberOfPages = slideContent.length;
    const onPrev = ()=>{
        if (currentPage === 0) setPage(numberOfPages - 1);
        else setPage(currentPage - 1);
        (0, $glT96.fireButtonAnalytics)(createAnalyticsEvent, 'previousSlide');
    };
    const onNext = ()=>{
        if (currentPage === numberOfPages - 1) setPage(0);
        else setPage(currentPage + 1);
        (0, $glT96.fireButtonAnalytics)(createAnalyticsEvent, 'nextSlide');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $8b76f2b498b3322b$var$CarouselWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ejOe8.UpdateAnimator), {
        animationOut: $8b76f2b498b3322b$var$FadeOutAnimation,
        animationIn: $8b76f2b498b3322b$var$FadeInAnimation,
        updateProps: {
            slide: slideContent[currentPage].component
        }
    }, ({ slide: slide })=>slide), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $8b76f2b498b3322b$var$ControlsWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $8b76f2b498b3322b$var$SlideCaptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ejOe8.UpdateAnimator), {
        animationOut: $8b76f2b498b3322b$var$FadeOutAnimation,
        animationIn: $8b76f2b498b3322b$var$FadeInAnimation,
        updateProps: {
            caption: slideContent[currentPage].caption
        }
    }, ({ caption: caption })=>caption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $8b76f2b498b3322b$var$CarouselControlsStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dXKde))), {
                label: "To previous",
                primaryColor: "var(--ds-icon-subtle, #626F86)"
            }),
        label: "To previous",
        onClick: onPrev
    }), slideContent.map((_, i)=>{
        const isSelected = currentPage === i;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            key: i,
            xcss: isSelected ? $8b76f2b498b3322b$var$IndicatorDotSelectedStyles : $8b76f2b498b3322b$var$IndicatorDotStyles
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
                label: "To next",
                primaryColor: "var(--ds-icon-subtle, #626F86)"
            }),
        label: "To next",
        onClick: onNext
    }))));
};
const $8b76f2b498b3322b$var$CarouselWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column',
    marginBottom: "var(--ds-space-300, 24px)"
});
const $8b76f2b498b3322b$var$fadeIn = null;
const $8b76f2b498b3322b$var$fadeOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8b76f2b498b3322b$var$FadeOutAnimation = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y44vyu25",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8b76f2b498b3322b$var$FadeInAnimation = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y44v1wd0",
            __cmplp.className
        ])
    });
});
const $8b76f2b498b3322b$var$BenefitsImageStyles = (0, $1ZAYh.xcss)({
    width: '400px',
    height: '250px',
    borderRadius: 'border.radius.100',
    boxShadow: 'elevation.shadow.overlay',
    overflow: 'hidden'
});
const $8b76f2b498b3322b$var$ControlsWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
const $8b76f2b498b3322b$var$SlideCaptionStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    textAlign: 'center',
    paddingTop: "var(--ds-space-300, 24px)",
    paddingBottom: "var(--ds-space-200, 16px)"
});
const $8b76f2b498b3322b$var$CarouselControlsStyles = (0, $1ZAYh.xcss)({
    height: '19px',
    display: 'flex',
    padding: 'space.0',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 'space.100',
    alignSelf: 'stretch'
});
const $8b76f2b498b3322b$var$IndicationDotStyle = {
    height: '8px',
    width: '8px',
    borderTopLeftRadius: '100px',
    borderTopRightRadius: '100px',
    borderBottomRightRadius: '100px',
    borderBottomLeftRadius: '100px'
};
const $8b76f2b498b3322b$var$IndicatorDotStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    ...$8b76f2b498b3322b$var$IndicationDotStyle,
    backgroundColor: 'color.background.accent.blue.subtler'
});
const $8b76f2b498b3322b$var$IndicatorDotSelectedStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    ...$8b76f2b498b3322b$var$IndicationDotStyle,
    backgroundColor: 'color.background.information.bold'
});

});
parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a2a4a1e4b9148f86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M9.005 10.995l4.593-4.593a.99.99 0 111.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 01-1.4 1.4L9.005 12.41a1 1 0 010-1.414z"/></svg>`
    }, props));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;
module.exports.default = $a2a4a1e4b9148f86$var$_default;

});

parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9d7d0ffff46f5f00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 010 1.414l-4.593 4.593a.99.99 0 01-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 011.4-1.4l4.593 4.593z"/></svg>`
    }, props));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;
module.exports.default = $9d7d0ffff46f5f00$var$_default;

});

parcelRegister("ejOe8", function(module, exports) {

$parcel$export(module.exports, "UpdateAnimator", () => $687d9518ca6f8f96$export$5790c81d12f4c05);

var $eUqFw = parcelRequire("eUqFw");

var $aFvYX = parcelRequire("aFvYX");
class $687d9518ca6f8f96$export$5790c81d12f4c05 extends (0, $eUqFw.Component) {
    render() {
        const animatedProps = this.state.prevUpdateProps || this.props.updateProps;
        return this.animationWrapper(this.props.children(animatedProps));
    }
    constructor(...args){
        super(...args);
        this.state = {
            prevUpdateProps: null,
            shouldAnimateIn: false,
            shouldAnimateOut: false
        };
        this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!(0, $aFvYX.default)(nextProps.updateProps, this.props.updateProps)) this.setState({
                prevUpdateProps: this.props.updateProps,
                shouldAnimateOut: true
            });
        };
        this.onAnimationOutEnd = ()=>{
            this.setState({
                prevUpdateProps: null,
                shouldAnimateOut: false,
                shouldAnimateIn: true
            });
        };
        this.onAnimationInEnd = ()=>{
            this.setState({
                shouldAnimateIn: false
            });
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.animationWrapper = (element)=>{
            const { animationOut: AnimationOut, animationIn: AnimationIn } = this.props;
            if (this.state.shouldAnimateOut) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AnimationOut, {
                onAnimationEnd: this.onAnimationOutEnd
            }, element);
            if (this.state.shouldAnimateIn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AnimationIn, {
                onAnimationEnd: this.onAnimationInEnd
            }, element);
            return element;
        };
    }
}

});
parcelRegister("aFvYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f24f9d4e9538bf7e$export$2e2bcd8739ae039);

var $5NVi6 = parcelRequire("5NVi6");
var /**
 * Shallow equal using '===' comparison and one-level array checks.
 *
 * WARNING: This is not a true shallow equal, use @atlassian/jira-platform-shallow-equal.
 *
 * @see {@link http://go.atlassian.com/shallow-equal}
 *
 * @param {*} obj1
 * @param {*} obj2
 * @returns {boolean}
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f24f9d4e9538bf7e$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    if (!(0, $5NVi6.default)(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const value = obj1[key];
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        return Array.isArray(nextValue) && Array.isArray(value) && (0, $5NVi6.default)(value, nextValue);
    });
    return areValuesEqual;
};

});
parcelRegister("5NVi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e4109ba822744d4$export$2e2bcd8739ae039);
/**
 * Returns true if the two given arrays are equal one level deep
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $8e4109ba822744d4$export$2e2bcd8739ae039 = (array1 = [], array2 = [])=>{
    // @ts-expect-error - This comparison appears to be unintentional because the types 'readonly T[]' and 'readonly U[]' have no overlap.
    if (array1 === array2) return true;
    // check one level deep
    // @ts-expect-error - This comparison appears to be unintentional because the types 'T' and 'U' have no overlap.
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};

});



parcelRegister("bd5FY", function(module, exports) {
module.exports = new URL("jpd-storage-limit.8d2e6784.png", import.meta.url).toString();

});

parcelRegister("iXOqR", function(module, exports) {
module.exports = new URL("jpd-user-limit.d8e72df9.png", import.meta.url).toString();

});

parcelRegister("iXX80", function(module, exports) {
module.exports = new URL("jsm-storage-limit.061b8778.png", import.meta.url).toString();

});

parcelRegister("6Qne0", function(module, exports) {
module.exports = new URL("jsm-user-limit.0196cbe5.png", import.meta.url).toString();

});

parcelRegister("9omrG", function(module, exports) {
module.exports = new URL("jsw-storage-limit.6d661396.png", import.meta.url).toString();

});

parcelRegister("7IOvW", function(module, exports) {
module.exports = new URL("jsw-user-limit.f13caea6.png", import.meta.url).toString();

});

parcelRegister("ch24A", function(module, exports) {

$parcel$export(module.exports, "BenefitsSlide", () => $d6fc870f0e5ddb38$export$c0f3d131ce71577);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $d3vNK = parcelRequire("d3vNK");

var $8IVhP = parcelRequire("8IVhP");

var $h0uXN = parcelRequire("h0uXN");

var $izGRi = parcelRequire("izGRi");

var $fXMW0 = parcelRequire("fXMW0");

var $ktq0D = parcelRequire("ktq0D");

var $8HBl8 = parcelRequire("8HBl8");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $7ZZxN = parcelRequire("7ZZxN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jRmiq = parcelRequire("jRmiq");

var $dNNmE = parcelRequire("dNNmE");
const $d6fc870f0e5ddb38$export$c0f3d131ce71577 = ({ projectType: projectType })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const benefitsMap = new Map(Object.entries({
        [(0, $7ZZxN.SOFTWARE_PROJECT)]: [
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fXMW0))), {
                    label: "Lock Icon"
                }),
                title: formatMessage((0, $dNNmE.default).userRolesAndPermissions),
                description: formatMessage((0, $dNNmE.default).haveMoreControl),
                iconBackgroundStyles: (0, $1ZAYh.xcss)({
                    backgroundColor: 'color.background.input'
                })
            },
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ktq0D))), {
                    label: "Person Circle Icon"
                }),
                title: formatMessage((0, $dNNmE.default).anonymousAccess),
                description: formatMessage((0, $dNNmE.default).giveSecureAccess),
                iconBackgroundStyles: (0, $1ZAYh.xcss)({
                    backgroundColor: 'color.background.input'
                })
            },
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
                    label: "Comment Icon"
                }),
                title: formatMessage((0, $dNNmE.default).businessHourSupport),
                description: formatMessage((0, $dNNmE.default).getSupport),
                iconBackgroundStyles: (0, $1ZAYh.xcss)({
                    backgroundColor: 'color.background.input'
                })
            }
        ],
        [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: [
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h0uXN))), {
                    label: "Dial Out Icon"
                }),
                title: formatMessage((0, $dNNmE.default).onCallManagement),
                description: formatMessage((0, $dNNmE.default).createCustomRules),
                iconBackgroundStyles: (0, $1ZAYh.xcss)({
                    backgroundColor: 'color.background.input'
                })
            },
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8IVhP))), {
                    label: "Email Icon"
                }),
                title: formatMessage((0, $dNNmE.default).unlimitedEmailNotifications),
                description: formatMessage((0, $dNNmE.default).updateEveryone),
                iconBackgroundStyles: (0, $1ZAYh.xcss)({
                    backgroundColor: 'color.background.input'
                })
            },
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
                    label: "Comment Icon"
                }),
                title: formatMessage((0, $dNNmE.default).businessHourSupport),
                description: formatMessage((0, $dNNmE.default).getSupport),
                iconBackgroundStyles: (0, $1ZAYh.xcss)({
                    backgroundColor: 'color.background.input'
                })
            }
        ],
        [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: [
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8HBl8))), {
                    label: "Unlock Icon"
                }),
                title: formatMessage((0, $dNNmE.default).customProjectRoles),
                description: formatMessage((0, $dNNmE.default).getMoreGranularity),
                iconBackgroundStyles: (0, $1ZAYh.xcss)({
                    backgroundColor: 'color.background.input'
                })
            },
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izGRi))), {
                    label: "Location Pin Icon"
                }),
                title: formatMessage((0, $dNNmE.default).dataResidency),
                description: formatMessage((0, $dNNmE.default).chooseDataHosting),
                iconBackgroundStyles: (0, $1ZAYh.xcss)({
                    backgroundColor: 'color.background.input'
                })
            },
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
                    label: "Comment Icon"
                }),
                title: formatMessage((0, $dNNmE.default).businessHourSupport),
                description: formatMessage((0, $dNNmE.default).getSupport),
                iconBackgroundStyles: (0, $1ZAYh.xcss)({
                    backgroundColor: 'color.background.input'
                })
            }
        ]
    }));
    const benefits = benefitsMap.get(projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d6fc870f0e5ddb38$var$ContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "small"
    }, formatMessage((0, $dNNmE.default).standardPlanSlideHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d6fc870f0e5ddb38$var$BenefitsBodyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRmiq.BenefitsList), {
        benefits: benefits || []
    })));
};
const $d6fc870f0e5ddb38$var$ContainerStyles = (0, $1ZAYh.xcss)({
    width: '400px',
    paddingTop: '0',
    paddingBottom: '0',
    paddingLeft: 'space.250',
    paddingRight: 'space.250',
    boxSizing: 'border-box'
});
const $d6fc870f0e5ddb38$var$BenefitsBodyStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'space.300',
    gap: 'space.300',
    height: '230px'
});

});
parcelRegister("d3vNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98143944cdbffe97$var$_react = $98143944cdbffe97$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $98143944cdbffe97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $98143944cdbffe97$var$CommentIcon = (props)=>/*#__PURE__*/ $98143944cdbffe97$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 00.164.033.515.515 0 00.474-.716z"/><rect x="7" y="9" width="10" height="2" rx="1"/><rect x="7" y="12" width="5" height="2" rx="1"/></g></svg>`
    }, props));
$98143944cdbffe97$var$CommentIcon.displayName = 'CommentIcon';
var $98143944cdbffe97$var$_default = $98143944cdbffe97$var$CommentIcon;
module.exports.default = $98143944cdbffe97$var$_default;

});

parcelRegister("8IVhP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $659edeb603307d4b$var$_react = $659edeb603307d4b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $659edeb603307d4b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $659edeb603307d4b$var$EmailIcon = (props)=>/*#__PURE__*/ $659edeb603307d4b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5 7v10h14V7H5zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h14z" fill-rule="nonzero"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 004.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.119 1.119 0 01-1.583 0L5.498 6.5z"/></g></svg>`
    }, props));
$659edeb603307d4b$var$EmailIcon.displayName = 'EmailIcon';
var $659edeb603307d4b$var$_default = $659edeb603307d4b$var$EmailIcon;
module.exports.default = $659edeb603307d4b$var$_default;

});

parcelRegister("h0uXN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c61a747196ebdfbb$var$_react = $c61a747196ebdfbb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c61a747196ebdfbb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c61a747196ebdfbb$var$HipchatDialOutIcon = (props)=>/*#__PURE__*/ $c61a747196ebdfbb$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M7.794 5.364c-1.726 2.133-.611 4.957.266 7.089.416 1.012 1.073 2.025 1.629 2.84.973 1.424 3.189 4.13 5.901 3.722 1.168-.176 2.527-1.555 1.597-2.436l-1.869-1.94s-.523-.436-1.171-.08l-1.048.613s-.428.202-.799-.275c-1.163-1.371-1.995-2.797-2.578-4.496-.227-.663.168-.828.168-.828l.767-.45c.637-.378.524-1.051.524-1.051l-.438-2.738c-.132-.568-.601-.803-1.145-.803-.648 0-1.4.334-1.804.833z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$c61a747196ebdfbb$var$HipchatDialOutIcon.displayName = 'HipchatDialOutIcon';
var $c61a747196ebdfbb$var$_default = $c61a747196ebdfbb$var$HipchatDialOutIcon;
module.exports.default = $c61a747196ebdfbb$var$_default;

});

parcelRegister("izGRi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d85cbdb8c81e089a$var$_react = $d85cbdb8c81e089a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d85cbdb8c81e089a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d85cbdb8c81e089a$var$LocationIcon = (props)=>/*#__PURE__*/ $d85cbdb8c81e089a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 21c-2.28 0-6-8.686-6-12a6 6 0 1112 0c0 3.314-3.72 12-6 12zm0-9a2.912 2.912 0 100-5.824A2.912 2.912 0 0012 12z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$d85cbdb8c81e089a$var$LocationIcon.displayName = 'LocationIcon';
var $d85cbdb8c81e089a$var$_default = $d85cbdb8c81e089a$var$LocationIcon;
module.exports.default = $d85cbdb8c81e089a$var$_default;

});

parcelRegister("fXMW0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9f253171a9f20fe$var$_react = $b9f253171a9f20fe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b9f253171a9f20fe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b9f253171a9f20fe$var$LockIcon = (props)=>/*#__PURE__*/ $b9f253171a9f20fe$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M16 11V9h-2V7.002A2.001 2.001 0 0012 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8h-1zm-2 0h-4V9h4v2zM8 9V7.002A4.004 4.004 0 0112 3a4 4 0 014 4.002V9h.994A2.01 2.01 0 0119 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.009 2.009 0 015 18.991V11.01C5 9.899 5.897 9 7.006 9H8zm0 0h2v2H8V9zm6 0h2v2h-2V9z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props));
$b9f253171a9f20fe$var$LockIcon.displayName = 'LockIcon';
var $b9f253171a9f20fe$var$_default = $b9f253171a9f20fe$var$LockIcon;
module.exports.default = $b9f253171a9f20fe$var$_default;

});

parcelRegister("8HBl8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $655f4dcb2f3febd5$var$_react = $655f4dcb2f3febd5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $655f4dcb2f3febd5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $655f4dcb2f3febd5$var$UnlockIcon = (props)=>/*#__PURE__*/ $655f4dcb2f3febd5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M5 11.009C5 9.899 5.897 9 7.006 9h9.988A2.01 2.01 0 0119 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.009 2.009 0 015 18.991V11.01zM7 11v8h10v-8H7z"/><circle cx="12" cy="15" r="2"/><path d="M8 6.251v-.249A4.004 4.004 0 0112 2a4 4 0 014 4.002V6.5h-2v-.498A2.001 2.001 0 0012 4c-1.102 0-2 .898-2 2.002V11H8V6.251zm6 .249h2a1 1 0 01-2 0z"/></g></svg>`
    }, props));
$655f4dcb2f3febd5$var$UnlockIcon.displayName = 'UnlockIcon';
var $655f4dcb2f3febd5$var$_default = $655f4dcb2f3febd5$var$UnlockIcon;
module.exports.default = $655f4dcb2f3febd5$var$_default;

});

parcelRegister("jRmiq", function(module, exports) {

$parcel$export(module.exports, "BenefitsList", () => $2d02c67ac8c6e470$export$ccb2870a847830f2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");
function $2d02c67ac8c6e470$export$ccb2870a847830f2(props) {
    const { benefits: benefits } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", {
        className: (0, $7JEyt.default)([
            "_qtt8glyw _19bvidpf"
        ])
    }, benefits.map((benefit, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: index,
            className: (0, $7JEyt.default)([
                "_n3tdpxbi _19pkidpf"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            key: benefit.title
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: [
                $2d02c67ac8c6e470$var$IconStyles,
                benefit.iconBackgroundStyles
            ]
        }, benefit.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $2d02c67ac8c6e470$var$BenefitTextStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: $2d02c67ac8c6e470$var$TitleStyles
        }, benefit.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, benefit.description)))))));
}
const $2d02c67ac8c6e470$var$IconStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.selected',
    borderRadius: 'border.radius.circle',
    display: 'flex',
    width: '40px',
    height: '40px',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: '0'
});
const $2d02c67ac8c6e470$var$BenefitTextStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column',
    marginLeft: "var(--ds-space-200, 16px)"
});
const $2d02c67ac8c6e470$var$TitleStyles = (0, $1ZAYh.xcss)({
    fontWeight: '700'
});
const $2d02c67ac8c6e470$var$BenefitsListStyles = null;
const $2d02c67ac8c6e470$var$BenefitsListItemStyles = null;

});

parcelRegister("dNNmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f101dc746445c24$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8f101dc746445c24$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    standardPlanSlideHeader: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.standard-plan-slide-header",
        "defaultMessage": "The Standard plan also includes:"
    },
    onCallManagement: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.on-call-management",
        "defaultMessage": "On-call management"
    },
    createCustomRules: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.create-custom-rules",
        "defaultMessage": "Create custom routing rules and escalation\xA0policies."
    },
    unlimitedEmailNotifications: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.unlimited-email-notifications",
        "defaultMessage": "Unlimited email notifications"
    },
    updateEveryone: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.update-everyone",
        "defaultMessage": "Update everyone about activity on requests."
    },
    businessHourSupport: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.business-hour-support",
        "defaultMessage": "Business hour support"
    },
    getSupport: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.get-support",
        "defaultMessage": "Get support from Atlassian\u2019s team of experts."
    },
    userRolesAndPermissions: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.user-roles-and-permissions",
        "defaultMessage": "User roles & permissions"
    },
    haveMoreControl: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.have-more-control",
        "defaultMessage": "Have more control over which users have access to different projects and actions."
    },
    anonymousAccess: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.anonymous-access",
        "defaultMessage": "Anonymous access"
    },
    giveSecureAccess: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.give-secure-access",
        "defaultMessage": "Give secure access to people outside your\xA0team."
    },
    customProjectRoles: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.custom-project-roles",
        "defaultMessage": "Custom project roles"
    },
    getMoreGranularity: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.get-more-granularity",
        "defaultMessage": "Get more granularity by creating custom project roles with specific permissions."
    },
    dataResidency: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.data-residency",
        "defaultMessage": "Data residency"
    },
    chooseDataHosting: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.choose-data-hosting",
        "defaultMessage": "Choose where you want your data hosted."
    }
});

});


parcelRegister("bnk3q", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b396ba0747e3426$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5b396ba0747e3426$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unlimitedUsers: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.unlimited-users",
        "defaultMessage": "Unlimited users"
    },
    unlimitedCreators: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.unlimited-creators",
        "defaultMessage": "Unlimited creators"
    },
    unlimitedAgents: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.unlimited-agents",
        "defaultMessage": "Unlimited agents"
    },
    increasedStorageLimits: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.increased-storage-limits",
        "defaultMessage": "Increased storage limits"
    },
    standardPlanFeatures: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.standard-plan-features",
        "defaultMessage": "Standard plan features"
    },
    jsmUserLimitImageAlt: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.jsm-user-limit-image-alt",
        "defaultMessage": "Adding users to Jira Service Management"
    },
    jsmStorageLimitImageAlt: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.jsm-storage-limit-image-alt",
        "defaultMessage": "Attaching attachments to Jira Service Management"
    },
    jswUserLimitImageAlt: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.jsw-user-limit-image-alt",
        "defaultMessage": "Adding users to Jira"
    },
    jswStorageLimitImageAlt: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.jsw-storage-limit-image-alt",
        "defaultMessage": "Attaching attachments to Jira"
    },
    jpdUserLimitImageAlt: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.jpd-user-limit-image-alt",
        "defaultMessage": "Adding users to Jira Product Discovery"
    },
    jpdStorageLimitImageAlt: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.jpd-storage-limit-image-alt",
        "defaultMessage": "Attaching attachments to Jira Product Discovery"
    }
});

});


parcelRegister("fMuUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d4aabeb5febfb27$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6d4aabeb5febfb27$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    headingAutoUpgrade: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.heading-auto-upgrade",
        "defaultMessage": "You\u2019ve been upgraded to Standard "
    },
    headingManualUpgrade: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.heading-manual-upgrade",
        "defaultMessage": "Welcome to {product}\xA0Standard "
    },
    description: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.description",
        "defaultMessage": "Your team has grown beyond the Free plan\u2019s 3 agent limit, so you\u2019ve been upgraded to the Standard plan."
    },
    softwareAutoUpgradeDescription: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.software-auto-upgrade-description",
        "defaultMessage": "Your team has grown beyond the Free plan\u2019s 10 user limit, so you\u2019ve been upgraded to the Standard plan."
    },
    softwareManualUpgradeDescription: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.software-manual-upgrade-description",
        "defaultMessage": "Your free 14-day trial of Jira Standard has started."
    },
    softwareManualUpgradeDescriptionSpork: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.software-manual-upgrade-description-spork",
        "defaultMessage": "Your free 14-day trial of Jira Standard has started."
    },
    serviceDeskAutoUpgradeDescription: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.service-desk-auto-upgrade-description",
        "defaultMessage": "Your team has grown beyond the Free plan\u2019s 3 agent limit, so you\u2019ve been upgraded to the Standard plan."
    },
    serviceDeskManualUpgradeDescription: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.service-desk-manual-upgrade-description",
        "defaultMessage": "Your free 14-day trial of Jira Service Management Standard has started."
    },
    productDiscoveryAutoUpgradeDescription: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.product-discovery-auto-upgrade-description",
        "defaultMessage": "Your team has grown beyond the Free plan\u2019s 3 creator limit, so you\u2019ve been upgraded to the Standard plan."
    },
    productDiscoveryManualUpgradeDescription: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.product-discovery-manual-upgrade-description",
        "defaultMessage": "Your free 14-day trial of Jira Product Discovery Standard has started."
    },
    later: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.later",
        "defaultMessage": "Later"
    },
    addPaymentDetails: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.add-payment-details",
        "defaultMessage": "Add payment details"
    }
});

});

parcelRegister("g2kkD", function(module, exports) {

$parcel$export(module.exports, "TimelineSection", () => $b66980346d86f310$export$4b1ab05634606afb);

var $eUqFw = parcelRequire("eUqFw");

var $kMHOY = parcelRequire("kMHOY");

var $1n6uL = parcelRequire("1n6uL");

var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $62EXj = parcelRequire("62EXj");

var $h8o42 = parcelRequire("h8o42");
function $b66980346d86f310$export$4b1ab05634606afb({ trialEndTime: trialEndTime }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    let formattedTrialStartMessage;
    let formattedTrialEndMessage;
    if (trialEndTime) {
        const trialDate = new Date(trialEndTime);
        const formattedEndDate = trialDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
        formattedTrialEndMessage = formatMessage((0, $h8o42.default).standardTrialEnds, {
            trialEndDate: formattedEndDate
        });
        trialDate.setDate(trialDate.getDate() - 14);
        const formmattedStartDate = trialDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
        formattedTrialStartMessage = formatMessage((0, $h8o42.default).standardTrialBegins, {
            trialStartDate: formmattedStartDate
        });
    } else {
        formattedTrialStartMessage = formatMessage((0, $h8o42.default).standardTrialBeginsWithoutDate);
        formattedTrialEndMessage = formatMessage((0, $h8o42.default).standardTrialEndsWithoutDate);
    }
    const timelineEvents = [
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1n6uL))), {
                label: "Premium Icon",
                size: "small"
            }),
            title: formattedTrialStartMessage,
            description: formatMessage((0, $h8o42.default).standardTrialBeginsDescription),
            iconBackgroundStyles: (0, $1ZAYh.xcss)({
                color: 'color.text.selected',
                borderColor: 'color.border.selected'
            })
        },
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
                label: "Calendar Icon",
                size: "small"
            }),
            title: formattedTrialEndMessage,
            description: formatMessage((0, $h8o42.default).standardTrialEndsDescription),
            iconBackgroundStyles: (0, $1ZAYh.xcss)({
                color: 'color.text.subtlest',
                borderColor: 'color.border'
            })
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: $b66980346d86f310$var$TimelineSectionStyles,
        testId: "upgrade-onboarding-experiment.ui.upgrade-onboarding-modal.timeline-section.benefits-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $62EXj.Timeline), {
        timelineEvents: timelineEvents
    }));
}
const $b66980346d86f310$var$TimelineSectionStyles = (0, $1ZAYh.xcss)({
    paddingTop: "var(--ds-space-300, 24px)"
});

});
parcelRegister("kMHOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f21a4850a620a60b$var$_react = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $f21a4850a620a60b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $f21a4850a620a60b$var$CalendarIcon = (props)=>/*#__PURE__*/ $f21a4850a620a60b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0119.005 21H4.995A1.995 1.995 0 013 19.006V6.994C3 5.893 3.892 5 4.995 5zM5 9v9a1 1 0 001 1h12a1 1 0 001-1V9H5zm1-5a1 1 0 012 0v1H6V4zm10 0a1 1 0 012 0v1h-2V4zm-9 9v-2.001h2V13H7zm8 0v-2.001h2V13h-2zm-4 0v-2.001h2.001V13H11zm-4 4v-2h2v2H7zm4 0v-2h2.001v2H11zm4 0v-2h2v2h-2z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$f21a4850a620a60b$var$CalendarIcon.displayName = 'CalendarIcon';
var $f21a4850a620a60b$var$_default = $f21a4850a620a60b$var$CalendarIcon;
module.exports.default = $f21a4850a620a60b$var$_default;

});

parcelRegister("62EXj", function(module, exports) {

$parcel$export(module.exports, "Timeline", () => $b6e74b989dc92ce5$export$e6a97ba2cae5bb94);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");
function $b6e74b989dc92ce5$export$e6a97ba2cae5bb94(props) {
    const { timelineEvents: timelineEvents } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, timelineEvents.map((timelineEvent, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            key: timelineEvent.title,
            xcss: $b6e74b989dc92ce5$var$TimelineEventContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: $b6e74b989dc92ce5$var$TimelineEventStyles,
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: [
                $b6e74b989dc92ce5$var$IconStyles,
                timelineEvent.iconBackgroundStyles
            ]
        }, timelineEvent.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $b6e74b989dc92ce5$var$TimelineEventContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: $b6e74b989dc92ce5$var$TitleStyles
        }, timelineEvent.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, timelineEvent.description))), index + 1 !== timelineEvents.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $b6e74b989dc92ce5$var$ConnectorStyles
        }))));
}
const $b6e74b989dc92ce5$var$IconStyles = (0, $1ZAYh.xcss)({
    border: '2px solid',
    borderRadius: 'border.radius.circle',
    display: 'flex',
    width: '32px',
    height: '32px',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: '0'
});
const $b6e74b989dc92ce5$var$TimelineEventStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'start'
});
const $b6e74b989dc92ce5$var$TimelineEventContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
const $b6e74b989dc92ce5$var$TimelineEventContentStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
const $b6e74b989dc92ce5$var$TitleStyles = (0, $1ZAYh.xcss)({
    fontWeight: '700'
});
const $b6e74b989dc92ce5$var$ConnectorStyles = (0, $1ZAYh.xcss)({
    backgroundImage: `linear-gradient(${`var(--ds-icon-disabled, ${(0, $PdmhA.DN400)})`} 50%, rgba(0,0,0,0) 0%)`,
    backgroundPosition: 'right',
    backgroundSize: '2px 8px',
    backgroundRepeat: 'repeat-y',
    height: `${"var(--ds-space-600, 40px)"}`,
    width: '2px',
    // creates symmetrical visual spacing between the top and bottom timeline items
    marginTop: "var(--ds-space-negative-100, -8px)",
    // centers the connector between the timeline icons
    // eslint-disable-next-line @atlaskit/design-system/use-latest-xcss-syntax
    marginLeft: '15px'
});

});

parcelRegister("h8o42", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c4efac44da8b227$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3c4efac44da8b227$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    standardTrialBegins: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.timeline-section.standard-trial-begins",
        "defaultMessage": "{trialStartDate}: Standard trial begins"
    },
    standardTrialBeginsWithoutDate: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.timeline-section.standard-trial-begins-without-date",
        "defaultMessage": "Standard trial begins"
    },
    standardTrialBeginsDescription: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.timeline-section.standard-trial-begins-description",
        "defaultMessage": "Explore Standard's powerful features"
    },
    standardTrialEnds: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.timeline-section.standard-trial-ends",
        "defaultMessage": "{trialEndDate}: Trial ends"
    },
    standardTrialEndsWithoutDate: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.timeline-section.standard-trial-ends-without-date",
        "defaultMessage": "Trial ends"
    },
    standardTrialEndsDescription: {
        "id": "upgrade-onboarding-experiment.upgrade-onboarding-modal.timeline-section.standard-trial-ends-description",
        "defaultMessage": "Add payment details to keep Standard features, or downgrade to Free."
    }
});

});








//# sourceMappingURL=async-upgrade-onboarding-experiment.46f7976f.js.map
